const es = {
  'header.customerService': 'Atención al cliente',
  "header.freeShipping": "Envío gratis a partir de {n} €",
  'header.login': 'Iniciar sesión',
  'header.admin': 'Administración',
  'header.myAccount': 'Mi cuenta',
  'header.myWishlist': 'Mi lista de deseos',
  'header.myOrders': 'Mis pedidos',
  'header.logout': 'Cerrar sesión',
  'header.parts': 'Piezas de recambio',
  'header.wholeCategory': 'Toda la categoría {name} →',
  'header.brands': 'Marcas',
  'header.guides': 'Guías',
  'header.topGuides': 'Guías más leídas',
  'header.allGuides': 'Todas las guías y consejos',
  'header.allBrandsAZ': 'Todas las marcas de la A a la Z ({count})',
  'header.removeVehicle': 'Quitar el vehículo',
  'header.createAccount': 'Crear una cuenta',
  'header.brandsAZ': 'Marcas de la A a la Z',
  'header.contact': 'Contacto',
  'header.language': 'Idioma',
  'header.searchPlaceholder': 'Buscar una pieza, una marca o una referencia',
  'header.searching': 'Buscando...',
  'header.noResults': 'Sin resultados para «{term}»',
  'header.openProduct': 'Abrir la ficha del producto',
  'header.matchesRef': 'Coincide con la ref. {kind}',

  'footer.tagline': '6,7 millones de piezas de automóvil en un mismo lugar',
  'footer.contactUs': 'Contáctenos',
  'footer.contact': 'Contacto',
  'footer.shipping': 'Envío y seguimiento',
  'footer.returns': 'Garantía y devoluciones',
  'footer.about': 'Quiénes somos',
  'footer.sitemap': 'Mapa del sitio',
  'footer.budget': 'Presupuesto de mantenimiento por modelo',
  'cookies.title': 'Cookies y medición de audiencia',
  'cookies.text': 'Utilizamos cookies necesarias para el funcionamiento del sitio (cesta, inicio de sesión) y, con su consentimiento, cookies de medición de audiencia (Google Analytics, PostHog) para mejorar OTOPIECES.COM. Sin publicidad. Su elección se conserva 6 meses.',
  'cookies.accept': 'Aceptar todo',
  'cookies.refuse': 'Rechazar',
  'cookies.customise': 'Personalizar',
  'cookies.save': 'Guardar mis opciones',
  'cookies.necessary': 'Cookies necesarias',
  'cookies.necessaryHint': 'siempre activas (cesta, sesión, preferencias)',
  'cookies.analytics': 'Medición de audiencia',
  'cookies.analyticsHint': 'estadísticas anónimas de navegación (Google Analytics, PostHog)',
  'cookies.close': 'Cerrar',
  'cookies.manage': 'Gestionar cookies',
  'cookies.statusOn': 'Medición de audiencia: activada. Puede cambiar su elección en cualquier momento.',
  'cookies.statusOff': 'Medición de audiencia: rechazada. Solo se utilizan cookies necesarias.',
  'cookies.statusNone': 'Aún no ha elegido: solo las cookies necesarias están activas.',
  'footer.securePayments': 'Pagos seguros:',
  'footer.fastShipping': "Envío a toda Europa",
  'footer.rights': '© 2026 OTOPIECES.COM. Todos los derechos reservados.',
  'footer.trademarks': 'Todas las marcas son propiedad de sus respectivos titulares.',

  'common.ref': 'Ref.',
  'common.addToCart': 'Añadir al carrito',
  'common.free': 'Gratis',
  'common.subtotal': 'Subtotal',
  'common.shipping': 'Envío',
  'common.total': 'Total',
  'common.vatIncluded': 'IVA incluido',
  'common.back': 'Volver',
  'common.continueShopping': 'Seguir comprando',
  'common.outOfStock': 'Agotado',
  'common.inStock': 'En stock',
  'common.lowStock': 'Solo quedan {n} en stock',
  'common.supplierStock': 'En nuestro proveedor · en {n} días',
  'common.compatible': 'Compatible',
  'common.cancel': 'Cancelar',
  'common.apply': 'Aplicar',
  'common.home': 'Inicio',
  'common.breadcrumb': 'Ruta de navegación',
  'common.unit': 'Unidad',
  'common.perUnit': '/ unidad',
  'common.discount': 'Descuento ({code})',
  'common.packAvailable': 'Disponible en {label}',
  'common.equivalentOther': 'Equivalente de otra marca (misma ref. OEM)',
  'common.oem': 'OEM ',
  'common.alternative': 'alternativa ',
  'common.bestPrice': 'Mejor precio del mercado',
  'common.bestPriceTitle': 'Precio comparado con {n} competidor(es){date}: OTOPIECES es el más barato.',
  'common.onDate': ' el {date}',

  'stock.out': 'Agotado',
  'stock.supplier': { one: 'Disponible en nuestro proveedor — enviado en {n} día', other: 'Disponible en nuestro proveedor — enviado en {n} días' },
  'stock.low': 'Solo quedan {n} en stock',
  'stock.lowSupplier': ' (+{s} en nuestro proveedor en {lead} días)',
  'stock.in': 'En stock',

  'product.notFound': 'Producto no encontrado',
  'product.backHome': 'Volver al inicio',
  'product.allParts': 'Todas las piezas {brand}',
  'product.manufacturerRef': 'Ref. fabricante:',
  'product.equivalentRef': 'Referencia equivalente',
  'product.oemRef': 'Referencia OEM del fabricante',
  'product.moreOem': { one: '+{n} otra ref. OEM', other: '+{n} otras ref. OEM' },
  'product.reviews': { one: '{n} opinión', other: '{n} opiniones' },
  'product.compatibleWith': 'Compatible con su ',
  'product.notGuaranteed': 'No garantizado para su ',
  'product.ttcExclShipping': 'IVA incl., sin envío',
  'product.tierBadge': '−{pct}% desde {n}',
  'product.cheaperAlt': 'Alternativa desde {price} € de {brand}',
  'product.cheaperAltCompat': 'Alternativa compatible desde {price} € de {brand}',
  'product.soldBy': 'Vendido por',
  'product.soldByDetail': 'Vendido por {n}{label} — {total} € {unitLabel}, es decir {unit} € / unidad',
  'product.theN': 'las {n}',
  'product.totalFor': 'Total para {n}:',
  'product.insteadOf': 'en lugar de {price} €',
  'product.outOfStockHint': 'Temporalmente agotado',
  'product.photoCheck': 'Verificar mi pieza por foto',
  'product.added': 'Añadido al carrito',
  'product.addPack': 'Añadir {qty}{label}',
  'product.viewCart': 'Ver el carrito',
  'product.delivery': 'Entrega en 2-5 días',
  "product.deliverySub": "Gratis desde {n} €",
  'product.return': 'Devolución 14 días',
  'product.returnSub': 'Satisfecho o reembolsado',
  'product.warranty': 'Garantía 2 años',
  'product.warrantySub': 'Piezas certificadas',
  'product.description': 'Descripción',
  'product.faqTitle': 'Preguntas frecuentes sobre este producto',
  'product.share': 'Compartir',
  'product.shareCopy': 'Copiar enlace',
  'product.shareCopied': 'Enlace copiado',
  'product.specs': 'Características',
  'product.compatibleVehicles': 'Vehículos compatibles',
  'product.universal': 'Producto universal: compatible con todos los vehículos.',
  'product.allModels': 'Todos los modelos',
  'spec.manufacturer': 'Fabricante',
  'spec.reference': 'Referencia',
  'spec.otherRefs': 'Otras referencias',
  'spec.oemRefs': 'Referencias OEM',
  'spec.category': 'Categoría',
  'product.alsoIn': 'También en',
  'product.relatedSubs': 'Otras piezas de {cat}',
  'product.relatedAll': 'Toda la categoría {cat}',
  'product.relatedMore': 'Ver todas (+{n})',
  'product.relatedLess': 'Ver menos',
  'product.relatedVehicles': 'Piezas compatibles por vehículo',
  'product.guides': 'Guías y consejos: {part}',
  'product.readGuide': 'Leer la guía',
  'cat.popularModels': '{part} para los modelos más buscados',
  'spec.features': 'Características',
  'spec.ean': 'Número EAN',
  'spec.condition': 'Estado',
  'spec.new': 'Nuevo',
  'spec.soldBy': 'Vendido por',
  'spec.packagings': 'Formatos',
  'spec.avgRating': 'Valoración media',
  'spec.avgRatingValue': '{r} / 5 ({n} opiniones)',
  'spec.warranty': 'Garantía',
  'spec.warrantyValue': '2 años mínimo',
  'spec.availability': 'Disponibilidad',

  'pack.title': 'Formato',
  'pack.units': '{n} unidades · {price} € / unidad',
  'pack.unitPrice': 'Precio unitario',
  'pack.insufficient': ' · stock insuficiente',
  'tiers.title': 'Precios decrecientes — compre más, pague menos',
  'tiers.quantity': 'Cantidad',
  'tiers.unitPrice': 'Precio unitario',
  'tiers.saving': 'Ahorro',
  'tiers.range': '{a} a {b}',
  'tiers.andMore': '{a} o más',
  'tiers.note': 'Descuento aplicado automáticamente en el carrito sobre el precio unitario.',
  'pro.ht': 'es decir {price} € sin IVA',
  'pro.discount': 'Precio pro −{pct} %: {price} € IVA incl. en el carrito',
  'wishlist.added': 'Añadido a su lista de deseos',
  'wishlist.removed': 'Eliminado de su lista de deseos',
  'wishlist.error': 'No se pudo actualizar la lista de deseos',
  'wishlist.remove': 'Quitar de la lista de deseos',
  'wishlist.add': 'Añadir a la lista de deseos',
  'wishlist.inList': 'En mi lista',
  'wishlist.addToList': 'Añadir a mi lista',
  'faq.askPrompt': '¿Una pregunta sobre esta pieza? Hágala, respondemos en 24 h.',
  'faq.ask': 'Hacer una pregunta',
  'faq.title': 'Preguntas frecuentes',
  'faq.seeAll': 'Ver todas las preguntas ({n})',
  'faq.answerFrom': 'Respuesta de {author}',
  'tyre.howMany': '¿Cuántos neumáticos?',
  'tyre.one': '1 neumático',
  'tyre.set4': 'Lote de 4 neumáticos',
  'tyre.n': '{n} neumáticos',
  'tyre.perTyre': '/ neumático',
  'tyre.insufficient': 'Stock insuficiente para un lote de 4 — contáctenos para una reposición.',
  'equiv.title': 'Esta pieza también existe en otras marcas',
  'equiv.count': { one: '{n} alternativa', other: '{n} alternativas' },
  'equiv.cheaper': { one: ' · {n} más barata', other: ' · {n} más baratas' },
  'equiv.compare': 'Comparar lado a lado ({n})',
  'similar.title': 'Productos similares',
  'similar.sub': '— {category} de otras marcas compatibles con los mismos vehículos',
  'similar.subVehicle': '— compatibles con su {vehicle}',
  'recent.title': 'Vistos recientemente',
  'recent.clear': 'Borrar',
  'fitments.count': '{n} motorización(es) · {b} marca(s)',
  'fitments.filter': 'Filtrar (marca, modelo, motor)',
  'fitments.models': { one: '· {n} modelo', other: '· {n} modelos' },
  'fitments.noMatch': 'Ninguna motorización coincide con «{q}».',
  'reviews.title': 'Opiniones de clientes',
  'reviews.outOf5': 'sobre 5',
  'reviews.loginPrompt': 'para opinar sobre un producto pedido.',
  'reviews.login': 'Inicie sesión',
  'reviews.already': 'Gracias, ya ha valorado este producto.',
  'reviews.rewardTitle': 'Deje su opinión y reciba un -{percent} % en su próximo pedido',
  'reviews.rewardText': 'Reservado a los clientes que han comprado este producto. Recibirá su código personal en cuanto se publique su opinión (válido {days} días).',
  'reviews.rewardLogin': 'Iniciar sesión para dejar mi opinión',
  'reviews.rewardWrite': 'Dejar mi opinión',
  'reviews.rewardAfterPurchase': 'Disponible tras la compra de este producto.',
  'reviews.rewardThanks': '¡Gracias por su opinión! Aquí tiene su código de -{percent} %',
  'reviews.rewardCopy': 'Copiar',
  'reviews.rewardCopied': 'Código copiado',
  'reviews.rewardValidity': 'Introdúzcalo en el carrito · válido hasta el {date}, un solo uso.',
  'reviews.rewardUsed': 'Código ya utilizado — ¡gracias!',
  'reviews.rewardMinOrder': 'a partir de {amount} € de compra',
  'reviews.customerPhotos': 'Fotos de nuestros clientes ({n})',
  'reviews.customerPhotosSee': 'Ver las opiniones',
  'reviews.customerPhotosHint': 'Fotos reales enviadas por compradores verificados junto con su opinión. Haga clic para ampliar.',
  'reviews.yourRating': 'Su valoración *',
  'reviews.titleField': 'Título',
  'reviews.titlePlaceholder': 'Resumen en pocas palabras',
  'reviews.comment': 'Comentario *',
  'reviews.commentPlaceholder': 'Calidad, montaje, relación calidad/precio...',
  'reviews.published': 'Su opinión ha sido publicada. ¡Gracias!',
  'reviews.empty': 'Aún no hay opiniones. ¡Sea el primero en compartir su experiencia!',
  'reviews.sortBy': 'Ordenar por',
  'reviews.merchantCollected': 'Opinión recogida por el comerciante',
  'reviews.verified': 'Compra verificada',
  'reviews.replyFrom': 'Respuesta de {author}',
  'reviews.sort.recent': 'Más recientes',
  'reviews.sort.helpful': 'Más útiles',
  'reviews.sort.photos': 'Con fotos primero',
  'reviews.share': 'Compartir',
  'home.google.badge': { one: 'en Google · {n} opinión', other: 'en Google · {n} opiniones' },
  'brand.trust.title': 'Índice de confianza',
  'brand.trust.summary': { one: '{n} opinión verificada en {p} producto(s) valorados', other: '{n} opiniones verificadas en {p} producto(s) valorados' },
  'brand.trust.recommended': { one: '{n} producto recomendado por nuestros clientes', other: '{n} productos recomendados por nuestros clientes' },
  'product.topBadge': 'Recomendado por nuestros clientes',
  'product.topBadgeHint': '{r}/5 de {n} opiniones verificadas',
  'reviews.translate': 'Traducir',
  'reviews.translatedByAi': 'Traducido automáticamente',
  'reviews.originalShown': 'Texto original',
  'reviews.showOriginal': 'Ver el original',
  'reviews.showTranslation': 'Ver la traducción',
  'reviews.translateError': 'Traducción no disponible',
  'home.google.title': 'Valoración Google',
  'home.google.count': { one: '{n} opinión en Google', other: '{n} opiniones en Google' },
  'home.google.link': 'Ver todas las opiniones en Google',
  'reviews.pendingNotice': '¡Gracias! Hemos recibido su opinión: se publicará tras una breve verificación por nuestro equipo.',
  'home.wall.kicker': 'Opiniones verificadas',
  'home.wall.title': 'Los conductores confían en nosotros',
  'home.wall.summary': { one: 'de {n} opinión verificada', other: 'de {n} opiniones verificadas' },
  'reviews.shareText': 'Mi opinión {stars} sobre {product}: «{comment}»',
  'reviews.shareMine': 'Comparta su opinión con sus allegados:',
  'reviews.sort.best': 'Mejores notas',
  'reviews.sort.worst': 'Notas más bajas',
  'questions.title': 'Preguntas y respuestas',
  'questions.ask': 'Hacer una pregunta',
  'questions.placeholder': 'Ej.: ¿Esta pieza es compatible con la versión familiar? ¿Se necesita una herramienta específica?',
  'questions.name': 'Su nombre *',
  'questions.email': 'Su e-mail * (para recibir la respuesta)',
  'questions.notice': 'Su pregunta se publicará con nuestra respuesta. ',
  'questions.notifyEmail': 'Se le avisará por e-mail.',
  'questions.emailPrivate': 'Su e-mail permanece privado.',
  'questions.empty': 'Aún no hay preguntas. ¿Dudas sobre compatibilidad o montaje? ¡Pregúntenos!',
  'questions.yours': 'Su pregunta',
  'questions.helped': '¿Le ha ayudado esta respuesta?',
  'gallery.prev': 'Foto anterior',
  'gallery.next': 'Foto siguiente',

  'cart.title': { one: 'Su carrito ({n} artículo)', other: 'Su carrito ({n} artículos)' },
  'cart.empty': 'Su carrito está vacío',
  'cart.discover': 'Descubrir nuestros productos',
  'cart.units': 'unidades',
  'cart.soldBy': 'Vendido por {n}',
  'cart.proPrice': 'precio pro',
  'cart.quantity': 'cantidad',
  'cart.summary': 'Resumen del pedido',
  'cart.promoLogin': '¿Un código promocional? Inicie sesión para aplicarlo.',
  "cart.freeShippingLeft": "¡Solo {amount} € más para el envío gratis!",
  'cart.checkout': 'Realizar pedido',
  'cartDrawer.title': 'Mi carrito',
  'cartDrawer.saveLater': 'Guardar para más tarde',
  'cartDrawer.fromWishlist': 'De su lista de deseos',
  'cartDrawer.goCart': 'Ir al carrito',
  'cartDrawer.checkout': 'Finalizar pedido',
  'cart.loginToOrder': 'Iniciar sesión para pedir',
  'cart.guestNotice': 'Su carrito se conservará al iniciar sesión o crear su cuenta.',
  "cart.freeShipping120": "Envío gratis desde {n} €",
  'cart.return14': 'Devolución en 14 días',
  'cart.securePayment': 'Pago 100 % seguro',
  'promo.placeholder': 'Código promocional',
  'promo.invalid': 'Código no válido',
  'promo.remove': 'Quitar el código',
  'savings.title': 'Usted ahorra',
  'alt.cheaper': 'Alternativa más barata de {brand}',
  'alt.perUnit': '−{d} € / unidad',
  'alt.total': ', −{s} € en total',
  'alt.replace': 'Reemplazar',
  'alt.replaced': '{name} reemplazado por {alt}',
  'alt.error': 'Reemplazo imposible',

  'checkout.backToCart': 'Volver al carrito',
  'checkout.stepShipping': 'Envío',
  'checkout.stepPayment': 'Pago',
  'checkout.stepConfirmation': 'Confirmación',
  'checkout.shippingAddress': 'Dirección de envío',
  'checkout.savedAddresses': 'Mis direcciones guardadas',
  'checkout.address': 'Dirección',
  'checkout.default': ' · por defecto',
  'checkout.defaultBilling': ' · facturación por defecto',
  'checkout.manageAddresses': 'Gestionar mis direcciones',
  'checkout.firstName': 'Nombre',
  'checkout.lastName': 'Apellidos',
  'checkout.email': 'Email',
  'checkout.phone': 'Teléfono',
  'checkout.addressComplement': 'Complemento de dirección',
  'checkout.complementPlaceholder': 'Piso, planta, edificio...',
  'checkout.postalCode': 'Código postal',
  'checkout.city': 'Ciudad',
  'checkout.otherBilling': 'Facturar a otra dirección',
  'checkout.invoiceFor': '· factura a nombre de {company}',
  'checkout.company': 'Empresa (opcional)',
  'checkout.vat': 'N.º IVA intracomunitario (opcional)',
  'checkout.continue': 'Continuar al pago',
  'checkout.paymentMethod': 'Método de pago',
  'checkout.autoPayNotice': 'Entrega en {address} (dirección guardada).',
  'checkout.autoPayEdit': 'Modificar la dirección',
  'checkout.card': 'Tarjeta bancaria',
  'checkout.cardInfo': 'Los datos de la tarjeta se solicitarán en la confirmación.',
  'checkout.ssl': 'Pago seguro SSL',
  'checkout.requested': { one: '{n} solicitado', other: '{n} solicitados' },
  'checkout.available': { one: '{n} disponible', other: '{n} disponibles' },
  'checkout.fixCart': 'Ajustar mi carrito',
  'checkout.country': 'País de entrega', 'checkout.carrier': 'Método de envío', 'checkout.relay': 'punto de recogida', 'checkout.errCountry': 'Todavía no entregamos en este país. Elija otro país de entrega.', 'cart.shippingEstimate': 'Estimación {country} · {carrier} — el transportista y el país se eligen en el siguiente paso',
  'checkout.tyreFree': 'Envío gratis a partir de 2 neumáticos', 'checkout.relayPick': 'Elegir mi punto de recogida', 'checkout.relayChange': 'Cambiar punto de recogida', 'checkout.relayRequired': 'Elija un punto de recogida Mondial Relay en el mapa.', 'checkout.relayTitle': 'Elija su punto de recogida',
  'checkout.weightTier': 'tarifa por peso ({w} kg)',
  'checkout.processing': 'Procesando...',
  'checkout.pay': 'Pagar {amount} €',
  'checkout.fastDelivery': 'Entrega rápida',
  'checkout.fastDeliverySub': '2-5 días laborables',
  'checkout.securePayment': 'Pago seguro',
  'checkout.sslSub': 'SSL 256 bits',
  'checkout.warranty': 'Garantía',
  'checkout.warrantySub': '2 años mínimo',
  'checkout.summary': 'Resumen',
  'checkout.qty': 'Cant.: {n}',
  'checkout.fitting': 'Montaje en centro asociado',
  'checkout.totalHT': 'Total sin IVA (cuenta pro)',
  'checkout.vatAmount': '· IVA {amount} €',
  'checkout.totalTTC': 'Total IVA incl.',
  'checkout.useWallet': 'Usar mi saldo ({amount} € disponibles)',
  'checkout.walletUsed': 'Saldo utilizado',
  'checkout.toPay': 'Pendiente de pago',
  'checkout.confirmed': '¡Pedido confirmado!',
  'checkout.thanks': 'Gracias por su pedido. Se ha enviado un email de confirmación a {email}',
  'checkout.orderNumber': 'Número de pedido',
  'checkout.deliveryTo': 'Entrega en',
  'checkout.viewOrders': 'Ver mis pedidos',
  'checkout.errRequired': 'El campo «{field}» es obligatorio',
  'checkout.errPostal': 'Código postal no válido (se esperan 5 cifras)',
  'checkout.errEmail': 'Dirección de email no válida',
  'checkout.errPhone': 'Número de teléfono no válido (ej.: 06 12 34 56 78)',
  'checkout.errBilling': 'Dirección de facturación incompleta (nombre o empresa, dirección, código postal, ciudad)',
  'checkout.errOrder': 'Error al realizar el pedido',
  'fitting.title': { one: 'Montaje de su {n} neumático', other: 'Montaje de sus {n} neumáticos' },
  'fitting.intro': 'Opcional: haga entregar sus neumáticos en un centro asociado que los montará y equilibrará. Elija una cita en su calendario o deje que el centro le contacte.',
  'fitting.sorted': ' Centros ordenados por fiabilidad y luego por distancia desde {place}.',
  'fitting.none': 'Sin montaje — entrega en la dirección indicada',
  'fitting.recommended': 'Recomendado',
  'fitting.distance': 'a {km} km',
  'fitting.bestRated': 'El mejor valorado cerca de usted',
  'fitting.hideReviews': 'Ocultar opiniones',
  'fitting.showReviews': 'Ver opiniones',
  'fitting.reliable': 'Socio fiable',
  'fitting.reliableTitle': 'Centro que confirma rápidamente sus citas',
  'fitting.online': 'Citas en línea',
  'fitting.perTyre': '/ neumático',
  'fitting.hidden': { one: '{n} centro asociado a más de {km} km no se propone.', other: '{n} centros asociados a más de {km} km no se proponen.' },
  'fitting.selected': 'Sus neumáticos se enviarán a {name} ({city}). Montaje + equilibrado: {total} añadidos al pedido.',
  'slot.loading': 'Cargando citas…',
  'slot.unavailable': 'Este centro aún no ha publicado sus citas: le contactará para fijar la cita tras el pedido.',
  'slot.choose': 'Elija su cita en {name}',
  'slot.centreProposes': 'El centro me propondrá una fecha',
  'slot.info': { one: 'Citas de {min} min, como muy pronto {d} día después del pedido (plazo de recepción de los neumáticos). El centro confirmará la cita por e-mail.', other: 'Citas de {min} min, como muy pronto {d} días después del pedido (plazo de recepción de los neumáticos). El centro confirmará la cita por e-mail.' },
  'slot.chosen': 'Cita deseada: {day} a las {time} — a confirmar por el centro.',

  'home.h1': "Recambios de coche online al mejor precio — piezas para todas las marcas",
  'home.h1Sub': "Más de 6.000 modelos referenciados: seleccione su vehículo o introduzca su matrícula para encontrar recambios 100 % compatibles. Grandes marcas, entrega en 2-5 días, devolución 14 días.",
  'home.seoTitle': "Recambios de coche baratos online — Piezas para todas las marcas | OTOPIECES.COM",
  'home.seoDesc': "Recambios de coche al mejor precio en OTOPIECES.COM: frenos, filtros, motor, neumáticos… Búsqueda por vehículo o matrícula, entrega 2-5 días, devolución 14 d.",
  'home.seoKeywords': "recambios coche, piezas de recambio, recambios baratos, recambios online, búsqueda por matrícula, pastillas de freno, filtro de aceite, neumáticos",
  'home.faqTitle': "Preguntas frecuentes sobre la compra de recambios online",
  'home.faq1q': "¿Cómo saber si una pieza es compatible con mi coche?",
  'home.faq1a': "Seleccione su vehículo (marca, modelo, año, motor) o introduzca su matrícula: el catálogo solo muestra los recambios compatibles, con la etiqueta «Compatible con su vehículo» en cada ficha de producto.",
  'home.faq2q': "¿Cuáles son los plazos y gastos de envío?",
  'home.faq2a': "Los pedidos se envían en 24-48 h y se entregan en 2-5 días laborables (Colissimo, Chronopost o punto de recogida Mondial Relay). El envío es gratuito a partir de cierto importe y desde 2 neumáticos.",
  'home.faq3q': "¿Puedo devolver una pieza que no me sirve?",
  'home.faq3a': "Sí, dispone de 14 días tras la recepción para devolver una pieza nueva, sin montar y en su embalaje original. El reembolso se realiza en los 14 días siguientes a la recepción del paquete.",
  'home.faq4q': "¿Las piezas tienen garantía?",
  'home.faq4a': "Todos los recambios vendidos en OTOPIECES.COM son nuevos, de grandes fabricantes (Bosch, Mann-Filter, TRW, Febi…) y cuentan con la garantía legal de conformidad de 2 años.",
  'home.faq5q': "¿Qué métodos de pago aceptan?",
  'home.faq5a': "El pago se realiza con tarjeta (Visa, Mastercard, Apple Pay, Google Pay) a través de la plataforma segura SumUp. Sus datos bancarios nunca pasan por nuestros servidores.",
  'home.faq6q': "¿Ofrecen el montaje de piezas o neumáticos?",
  'home.faq6a': "Sí, al realizar el pedido puede reservar una cita de montaje en uno de nuestros centros asociados. Sus piezas se entregan allí directamente y las monta un profesional.",
  'acc.bankSecureNote': "Sus pagos se procesan de forma segura a través de SumUp. Las tarjetas guardadas aquí son solo un recordatorio: únicamente se conservan los 4 últimos dígitos, nunca el número completo.",
  'new.menu': "Novedades",
  'new.menuHint': "{n} pieza(s) añadida(s) esta semana",
  'new.title': "Novedades",
  'new.h1': "Novedades: piezas añadidas en los últimos {d} días",
  'new.sub': "Los últimos recambios añadidos al catálogo, ordenados por fecha. Seleccione su vehículo para ver solo las piezas compatibles.",
  'new.days': "{d} días",
  'new.onlyVehicle': "Solo compatibles con mi vehículo",
  'new.selectVehicle': "Seleccione su vehículo para filtrar las novedades compatibles",
  'new.allCats': "Todas las categorías",
  'new.empty': "No hay novedades para estos criterios.",
  'new.showAll': "Mostrar todas las novedades",
  'new.seoTitle': "Novedades en recambios — últimas piezas añadidas",
  'new.seoDesc': "Descubra los recambios de coche añadidos en los últimos {d} días en OTOPIECES.COM: frenos, filtros, motor… filtrables por vehículo compatible.",
  'new.badge': "Nuevo",
  'new.homeTitle': "Novedades de la semana",
  'new.homeCount': "{n} pieza(s) añadida(s) en los últimos 7 días",
  'new.homeAll': "Todas las novedades",
  'new.subTitleAll': "Reciba las novedades de la semana por correo",
  'new.subTitleCat': "Reciba las novedades «{name}» por correo",
  'new.subHint': "Un solo correo los lunes, solo si hay novedades. Baja en un clic.",
  'new.subButton': "Suscribirme",
  'new.subOk': "Suscripción guardada",
  'new.subAlready': "Ya estaba suscrito — suscripción reactivada",
  'new.subError': "No se pudo suscribir",
  'new.subDone': "¡Hecho! Las novedades ({scope}) se enviarán cada lunes a {email}.",
  'new.subManage': "Gestionar mis suscripciones",
  'new.subRemoved': "Suscripción eliminada",
  'new.subsTitle': "Novedades por correo",
  'new.subsHint': "Cada lunes, las piezas añadidas al catálogo en las categorías que elija.",
  'new.subsEmpty': "Sin suscripción. Suscríbase desde la página",
  'new.subsSince': "Desde el {d}",
  'new.subsLast': "último envío {d}",
  'common.loadError': "La carga ha fallado. Compruebe su conexión e inténtelo de nuevo.",
  'common.retry': "Reintentar",
  'product.movedToCategory': "Este producto ya no está disponible — aquí tiene su categoría.",
  'home.selectVehicle': 'Seleccione su vehículo',
  'home.brand': 'MARCA',
  'home.model': 'MODELO',
  'home.year': 'AÑO',
  'home.engine': 'MOTORIZACIÓN',
  'home.chooseBrand': 'Elegir una marca',
  'home.chooseModel': 'Elegir un modelo',
  'home.chooseYear': 'Elegir el año',
  'home.chooseEngine': 'Elegir la motorización',
  'home.search': 'Buscar...',
  'home.topBrands': 'Marcas más vendidas',
  'home.allBrands': 'Todas las marcas',
  'home.noBrand': 'Ninguna marca encontrada',
  'home.noModel': 'Ningún modelo encontrado',
  'home.selectModel': 'Seleccione un modelo',
  'home.selectYear': 'Seleccione un año',
  'home.noEngine': 'Ninguna motorización disponible',
  'home.selectedVehicle': 'Vehículo seleccionado',
  'home.orPlate': 'o busque por matrícula',
  'home.plateLabel': '¿Conoce su matrícula? Búsquela en nuestro registro',
  'home.searchBtn': 'Buscar',
  'home.plateRequired': 'Introduzca su número de matrícula',
  'home.plateNotFound': 'Vehículo no encontrado para esta matrícula',
  'home.identified': 'Vehículo identificado:',
  'home.simulated': '(identificación simulada)',
  'home.seeParts': 'Ver las piezas compatibles',
  'home.allVehicleBrands': 'Todas las marcas de vehículos',
  'home.notFoundCar': '¿No encuentra su coche en el catálogo?',
  'home.categoriesTitle': 'Encuentre piezas de recambio en el catálogo de OTOPIECES.COM',
  'home.moreParts': 'Más piezas de recambio',
  'home.accessoriesTitle': 'Esenciales para el coche: accesorios, productos de limpieza y herramientas',
  'home.allSubcategories': 'Todas las subcategorías ({n})',
  'home.trust.return': 'Devolución en 14 días',
  'home.trust.returnSub': 'Satisfecho o reembolsado',
  'home.trust.payments': 'Pagos seguros',
  'home.trust.app': 'Una app muy práctica',
  'home.trust.appSub': 'para comprar piezas de automóvil',
  'home.trust.videos': 'Vídeos de reparación',
  'home.trust.videosSub': 'Guías en vídeo',
  'home.bestsellers': 'Los más vendidos de OTOPIECES.COM: compre piezas de recambio a precios ventajosos',
  'home.compatibleParts': 'Piezas compatibles con su {vehicle}',
  'home.compatibleCount': '{n} piezas compatibles',
  'home.seeAllCompatible': 'Ver todas las piezas compatibles',
  'home.addedToCart': '¡Producto añadido al carrito!',
  'home.addError': 'Error al añadir al carrito',
  'home.carBrands': 'Piezas de automóvil para las marcas de coche más solicitadas',
  'home.topModels': 'Los modelos de vehículos más consultados',
  'home.topModelsAll': 'Todas las marcas',
  'home.topModelsParts': 'Piezas compatibles',
  'home.recentVehicles': 'Sus últimos vehículos',
  'home.recentClear': 'Borrar',
  'garage.compareTitle': 'Comparar piezas compatibles',
  'garage.compareButton': 'Comparar',
  'garage.compareThird': '+ 3er vehículo (opcional)',
  'garage.budgetTitle': 'Presupuesto anual de mantenimiento estimado',
  'garage.budgetHint': 'Estimación a partir de las piezas compatibles del catálogo (piezas de desgaste × frecuencia habitual de sustitución). Precio mediano, o «eco» = pieza más barata.',
  'garage.budgetPerYear': ' / año',
  'garage.dropBadge': 'Presupuesto reducido {amount}/año desde el {date}',
  'garage.historyTitle': 'Evolución del presupuesto en 12 meses',
  'garage.historyMedian': 'Presupuesto estimado',
  'garage.historyEco': 'Presupuesto eco',
  'garage.historyEmpty': 'El historial empieza hoy: se registra un punto cada día, la curva se irá formando en las próximas semanas.',
  'garage.historyChange': 'Variación en el periodo',
  'garage.historyAlert': 'Alerta de bajada enviada',
  'garage.historyRange': 'Mín {min} · Máx {max}',
  'garage.budgetEco': 'Eco:',
  'garage.budgetEcoTotal': 'Presupuesto eco:',
  'garage.budgetCoverage': '{n} partida(s) estimada(s) de {total}',
  'garage.budgetNoParts': 'Todavía no hay piezas de mantenimiento compatibles para este vehículo.',
  'garage.budgetPost': 'Partida',
  'garage.budgetInterval': 'Frecuencia',
  'garage.budgetEstimated': 'Precio mediano',
  'garage.budgetPerYearCol': 'Por año',
  'garage.budgetParts': 'pieza(s) compatible(s)',
  'garage.budgetEvery': 'cada {n} año(s)',
  'garage.budgetMissing': 'No estimados (aún sin pieza compatible):',
  'garage.budgetSeeParts': 'Ver todas las piezas compatibles →',
  'garage.budgetUpcoming': 'A prever en 12 meses:',
  'garage.logCol': 'Libro de mantenimiento',
  'garage.logReplaced': 'Sustituido el…',
  'garage.logNext': 'Al día · próximo: {d}',
  'garage.logOverdue': 'Plazo superado',
  'garage.logEdit': 'modificar',
  'garage.logClear': 'Borrar',
  'garage.logSaved': 'Libro de mantenimiento actualizado',
  'garage.logError': 'No se pudo guardar',
  'garage.logTracked': '{n} partida(s) registrada(s)',
  'garage.logHint': 'Indique la fecha (y el kilometraje) de la última sustitución: el próximo plazo es el más cercano entre fecha + frecuencia y km + intervalo (convertido con su kilometraje anual). La partida sale del presupuesto «a 12 meses» hasta entonces; el presupuesto anual no cambia.',
  'garage.logKm': 'km en la sustitución',
  'garage.logKmCurrent': 'km actuales del vehículo',
  'garage.logKmAt': 'a {km}',
  'garage.logOrKm': 'o {km}',
  'garage.logMileage': '≈ {km} hoy',
  'garage.logFromOrder': 'comprado en OTOPIECES ({d})',
  'garage.carnetPdf': 'Descargar el libro (PDF)',
  'garage.carnetPdfDone': 'Libro de mantenimiento descargado',
  'garage.carnetEmail': 'Recibir mi libro por e-mail',
  'garage.carnetEmailDone': 'Libro de mantenimiento enviado a {email}',
  'home.seeBrands': 'Ver las {n} marcas',
  'home.partsFor': 'Piezas de automóvil {brand}',
  'home.models': '{n} modelos',
  'home.manufacturers': 'Ofertas excepcionales en piezas de automóvil de los mayores fabricantes',
  'home.articles': 'Todo para su coche: guías y consejos de expertos',
  'home.learnMore': 'Saber más',
  'home.aboutTitle': "Recambios de coche online: todo para el mantenimiento y la reparación de su vehículo",
  'home.about1a': "OTOPIECES.COM es su tienda online de ",
  'home.about1b': "recambios de coche baratos",
  'home.about1c': ": frenos (discos, pastillas, pinzas), filtros (aceite, aire, habitáculo, combustible), motor, suspensión, dirección, iluminación, escape, neumáticos y llantas. Sea particular, aficionado a la mecánica o taller, aquí encontrará la pieza adecuada para su vehículo al mejor precio.",
  'home.about2a': "Cada referencia se comprueba para garantizar la ",
  'home.about2b': "compatibilidad con su coche",
  'home.about2c': ": seleccione marca, modelo, año y motor, o introduzca simplemente su matrícula. El catálogo solo muestra las piezas compatibles, con sus referencias de origen (OE) y equivalencias entre fabricantes para comparar y elegir con total confianza.",
  'home.about3': "Solo ofrecemos piezas nuevas de los grandes fabricantes (Bosch, Mann-Filter, TRW, Febi, Valeo…), cubiertas por la garantía legal de 2 años. ¿Una duda sobre la elección de una pieza, su montaje o su compatibilidad? Nuestro servicio de atención al cliente, formado por especialistas en recambios, le responde rápidamente por chat, correo o teléfono.",
  'home.about4a': "Pida sus recambios en unos clics con ",
  'home.about4b': "pago seguro y entrega en 2 a 5 días",
  'home.about4c': " en Francia y Europa (domicilio o punto de recogida), devolución en 14 días y posibilidad de reservar el montaje en un centro asociado. OTOPIECES.COM: el recambio al precio justo, para todos los modelos de vehículo.",
  'reviews.errRating': 'Elija una nota de 1 a 5 estrellas',
  'reviews.errShort': 'Su comentario es demasiado corto (10 caracteres mínimo)',
  'reviews.errSend': 'Error al enviar su opinión',
  'reviews.verifiedCount': { one: '{n} opinión verificada', other: '{n} opiniones verificadas' },
  'reviews.withPhotos': { one: '{n} con foto', other: '{n} con fotos' },
  'reviews.notAllowed': 'Solo los clientes que han pedido este producto pueden dejar una opinión.',
  'reviews.yourReviewOn': 'Su opinión sobre {name}',
  'reviews.invite': 'Gracias por tomarse el tiempo de compartir su experiencia con esta pieza.',
  'reviews.submit': 'Publicar mi opinión',
  'reviews.reported': 'Gracias, nuestro equipo revisará esta opinión.',
  'questions.voteError': 'Voto imposible',
  'questions.pending': 'Pendiente de respuesta — visible solo para usted',
  'questions.errShort': 'Su pregunta es demasiado corta (10 caracteres mínimo)',
  'questions.errName': 'Indique su nombre',
  'questions.errEmail': 'Indique un e-mail válido para recibir la respuesta',
  'questions.yourQuestionOn': 'Su pregunta sobre {name}',
  'questions.send': 'Enviar mi pregunta',
  'tyre.summer': 'Neumático de verano', 'tyre.winter': 'Neumático de invierno', 'tyre.allSeason': 'Neumático 4 estaciones', 'tyre.car': 'Turismo', 'tyre.van': 'Furgoneta',
  'tyre.size': 'Dimensión', 'tyre.indexes': 'Índices de carga / velocidad', 'tyre.season': 'Temporada', 'tyre.vehicleType': 'Tipo de vehículo', 'tyre.euLabel': 'Etiqueta UE',
  'tyre.fuel': 'Consumo', 'tyre.wet': 'Adherencia', 'tyre.specifics': 'Particularidades', 'tyre.xlSpec': 'XL (reforzado)', 'tyre.pcd': 'Distancia entre tornillos', 'tyre.offset': 'Offset (ET)',
  'tyre.centerBore': 'Diámetro central', 'tyre.material': 'Material', 'tyre.steel': 'Acero (chapa)', 'tyre.aluminium': 'Aluminio', 'tyre.finish': 'Acabado',
  'tyre.steelWheel': 'Llanta de chapa', 'tyre.aluWheel': 'Llanta de aluminio', 'tyre.snowflake': '3PMSF · homologado Ley de Montaña', 'tyre.xl': 'XL reforzado',
  'tyre.euLabelView': 'Etiqueta completa y PDF', 'tyre.euLabelFull': 'Etiqueta europea', 'tyre.fuelFull': 'Eficiencia en combustible', 'tyre.noiseFull': 'Ruido de rodadura externo', 'tyre.snowGrip': 'Agarre en nieve (3PMSF)', 'tyre.noSnowMark': 'Sin marcado nieve / hielo', 'tyre.labelDisclaimer': 'Documento informativo basado en datos del proveedor; la etiqueta oficial es la del fabricante.',
  'tyre.euLabelLine1': 'Etiqueta', 'tyre.euLabelLine2': 'europea', 'tyre.fuelHint': 'Eficiencia energética (A = mejor)', 'tyre.wetGrip': 'Adherencia en mojado',
  'tyre.wetHint': 'Frenado en mojado (A = mejor)', 'tyre.noiseTitle': 'Ruido de rodadura externo', 'tyre.noiseClass': 'Ruido · clase {c}',
  "acc.dashboard": "Mi OTOPIECES",
  "acc.garage": "Mi garaje",
  "acc.maintenance": "Libro de mantenimiento",
  "acc.maintenanceTitle": "Libro de mantenimiento predictivo",
  "acc.sellerListings": "Mis anuncios de ocasión",
  "acc.sellerImport": "Importar mi catálogo",
  "acc.sellerFeeds": "Sincronización de mi catálogo",
  "acc.sellerOrders": "Mis pedidos de ocasión",
  "acc.seller": "Convertirse en vendedor",
  "acc.pro": "Cuenta profesional",
  "acc.orders": "Mis pedidos",
  "acc.wishlist": "Mi lista de deseos",
  "acc.addresses": "Mi libreta de direcciones",
  "acc.bank": "Datos bancarios",
  "acc.wallet": "Mi cuenta de saldo",
  "acc.settings": "Ajustes",
  "acc.compare": "Comparación",
  "acc.logout": "Cerrar sesión",
  "acc.proValidated": "Cuenta profesional validada",
  "acc.myAccount": "Mi cuenta",
  "acc.proBannerOk": "Cuenta profesional validada — {company}",
  "acc.proBannerPending": "Solicitud de cuenta profesional en validación ({company})",
  "acc.proBannerRefused": "Su solicitud de cuenta profesional ha sido rechazada",
  "acc.details": "Detalles",
  "acc.openOrders": "{n} en curso · {spent} gastados",
  "acc.spent": "{spent} gastados",
  "acc.walletCard": "Cuenta de saldo",
  "acc.walletHint": "Saldo utilizable al pagar",
  "acc.wishlistCard": "Lista de deseos",
  "acc.wishlistHint": "piezas seguidas",
  "acc.vehiclesHint": "vehículo(s) registrado(s)",
  "acc.addressesCard": "Libreta de direcciones",
  "acc.addressesHint": "dirección(es)",
  "acc.cards": "{n} tarjeta(s)",
  "acc.ibanYes": "IBAN registrado",
  "acc.ibanNo": "Sin IBAN",
  "acc.lastOrder": "Último pedido",
  "acc.viewOrders": "Ver mis pedidos",
  "acc.proCta": "¿Es usted un profesional del automóvil?",
  "acc.proCtaSub": "Solicite su cuenta profesional: precios sin IVA, facturas a nombre de su empresa, insignia Pro.",
  "acc.personalInfo": "Información personal",
  "acc.savedAddress": "Dirección de envío guardada",
  "acc.password": "Contraseña",
  "acc.prefs": "Preferencias de visualización y notificaciones",
  "acc.language": "Idioma",
  "acc.currency": "Moneda",
  "acc.orderEmails": "E-mails de seguimiento de pedido (confirmación, envío)",
  "acc.marketing": "Ofertas y promociones personalizadas",
  "acc.delete": "Eliminar mi cuenta",
  "acc.deleteInfo": "Sus direcciones, vehículos, listas y tarjetas se borrarán. Sus facturas siguen disponibles a través de nuestro servicio de atención al cliente.",
  "acc.deleteConfirm": "Eliminar definitivamente",
  "acc.currentPwd": "Contraseña actual *",
  "acc.newPwd": "Nueva contraseña * (8 caracteres mín.)",
  "acc.confirmPwd": "Confirmar la nueva contraseña *",
  "acc.showPwd": "Mostrar",
  "acc.hidePwd": "Ocultar",
  "acc.pwdWord": "las contraseñas",
  "acc.docLang": "Idioma de los documentos (facturas, e-mails)",
  "acc.defaultShipping": "Dirección de envío por defecto",
  "acc.defaultBilling": "Dirección de facturación por defecto",
  "acc.addressesInfo": "Sus direcciones se proponen al realizar el pedido. La dirección de envío por defecto se rellena automáticamente.",
  "acc.bankAccount": "Cuenta bancaria (reembolsos)",
  "acc.bankInfo": "Utilizada únicamente para reembolsarle en caso de devolución o cancelación.",
  "acc.saveIban": "Guardar el IBAN",
  "acc.cardsInfo": "Para pedir más rápido. El número completo nunca se conserva.",
  "acc.default": "Por defecto",
  "acc.remove": "Eliminar",
  "acc.save": "Guardar",
  "acc.history": "Historial de movimientos",
  "acc.proInfo": "Talleres, carroceros, distribuidores: precios sin IVA, facturación con su n.º de IVA e insignia Pro.",
  "acc.editInfo": "Modificar la información",
  "acc.withdraw": "Retirar mi solicitud",
  "acc.companyName": "Razón social *",
  "acc.siret": "SIRET * (14 cifras)",
  "acc.vatNumber": "N.º IVA intracomunitario",
  "acc.sector": "Sector de actividad *",
  "acc.companyPhone": "Teléfono de la empresa",
  "acc.proof": "Justificante (enlace Kbis / URL) — opcional",
  "orders.loginPrompt": "Inicie sesión para ver sus pedidos",
  "orders.login": "Iniciar sesión",
  "orders.empty": "Aún no ha realizado ningún pedido",
  "orders.order": "Pedido {n}",
  "orders.vehicle": "Vehículo",
  "orders.reorderVehicle": "Volver a comprar para mi coche",
  "orders.reorderOk": "{n} artículo(s) añadido(s) al carrito",
  "orders.reorderPartial": "{n} artículo(s) añadido(s) · {s} no disponible(s)",
  "orders.reorderNone": "Ningún artículo de este pedido está disponible actualmente.",
  "orders.filterVehicle": "Filtrar por vehículo",
  "orders.filterAll": "Todos",
  "orders.filterNoVehicle": "Sin vehículo",
  "orders.filterEmpty": "No hay pedidos para este vehículo.",
  "orders.cancelHint": "¿Ha cambiado de opinión? Puede cancelar mientras el pedido no esté en preparación.",
  "orders.cancel": "Cancelar mi pedido",
  "orders.cancelled": "Este pedido ha sido cancelado.",
  "orders.refunded": "Este pedido ha sido reembolsado.",
  "orders.tracking": "Seguimiento del paquete — {carrier}",
  "orders.track": "Seguir mi paquete",
  "orders.review": "Dejar una opinión",
  "orders.walletUsed": "Saldo utilizado (cuenta de saldo)",
  "orders.paid": "pagado {amount} €",
  "orders.fittingAt": "Montaje en {name}",
  "orders.fitTyres": { one: "{n} neumático", other: "{n} neumáticos" },
  "orders.fitRequested": "Franja solicitada: {d} — pendiente de confirmación por el centro.",
  "orders.fitConfirmed": "Cita confirmada: {d}",
  "orders.fitContact": "El centro se pondrá en contacto con usted para fijar la cita{p}.",
  "orders.fitReview": "Valorar este centro de montaje",
  "orders.fitRating": "Su valoración del centro: {r}/5 — ¡gracias!",
  "appt.locked": "Cita en menos de {h} h: para modificarla, contacte con el centro{p}.",
  "appt.actionFailed": "Acción imposible",
  "appt.moved": "Cita desplazada — el centro debe confirmar la nueva franja",
  "appt.requested": "Franja solicitada — el centro debe confirmarla",
  "appt.confirmCancel": "¿Anular esta cita? El montaje sigue previsto; el centro le propondrá otra fecha.",
  "appt.cancelled": "Cita anulada — se ha avisado al centro",
  "appt.confirmCancelService": "¿Anular definitivamente el montaje en {name}?\n\nEl importe del montaje ({a} €) se le reembolsará como saldo en su cuenta y se generará un abono en PDF. Sus neumáticos siguen pedidos.",
  "appt.serviceCancelled": "Montaje anulado — {a} € abonados en su saldo",
  "appt.move": "Cambiar la cita",
  "appt.pick": "Elegir una franja",
  "appt.cancelSlot": "Anular la franja",
  "appt.cancelService": "Anular el montaje (abono)",
  "appt.newSlot": "Nueva franja en {name}",
  "appt.loadingCal": "Cargando el calendario…",
  "appt.noCalendar": "Este centro no tiene calendario en línea: indique la fecha deseada (con al menos {h} h de antelación); el centro la confirmará.",
  "appt.request": "Solicitar esta franja",
  "appt.centreConfirms": "El centro recibe un correo y confirma la franja.",
  "appt.changes": { one: "{n} modificación de cita — última: {last}", other: "{n} modificaciones de cita — última: {last}" },
  "appt.chCancelled": "anulación",
  "appt.chReassigned": "reasignación a {c}",
  "appt.chMoved": "cambio a {d}",
  "orders.cancelledToast": "Pedido cancelado. Los artículos han vuelto al stock.",
  "orders.cancelError": "No se puede cancelar este pedido",
  "status.En attente": "Pendiente",
  "status.En cours": "En curso",
  "status.Expédié": "Enviado",
  "status.Livré": "Entregado",
  "status.Annulée": "Cancelado",
  "status.Remboursée": "Reembolsado",
  "cat.products": "Productos",
  "cat.found": { one: "{n} producto encontrado", other: "{n} productos encontrados" },
  "cat.filterBy": "Filtrar por",
  "cat.brand": "Marca",
  "cat.noBrand": "Ninguna marca",
  "cat.price": "Precio (€)",
  "cat.noneFilters": "Ningún producto coincide con sus filtros",
  "cat.noneVehicle": "Ninguna pieza compatible con su vehículo en esta categoría",
  "cat.none": "Ningún producto encontrado en esta categoría",
  "cat.related": "Búsquedas relacionadas",
  "cat.filters": "Filtros",
  "search.filterCategory": "Categoría",
  "search.noneWithFilters": "Ningún resultado con estos filtros.",
  "cat.sortRelevance": "Relevancia",
  "cat.sortPriceAsc": "Precio ascendente",
  "cat.sortPriceDesc": "Precio descendente",
  "cat.sortRating": "Mejores notas",
  "cat.sortDiscount": "Mejores descuentos",
  "cat.sortNewest": "Novedades",
  "cat.bestPriceTitle": "Mostrar solo los productos en los que OTOPIECES es más barato que todos los competidores seguidos",
  "cat.sortBy": "Ordenar por",
  "cat.collapse": "Reducir",
  "cat.moreSubs": "Ver las otras {n} subcategorías",
  "cat.yourVehicle": "Su vehículo",
  "cat.onlyCompatible": "Ver solo las piezas compatibles",
  "cat.allParts": "Ver todas las piezas",
  "cat.change": "Cambiar",
  "acc.newsletter": "Recibir las ofertas y el boletín de OTOPIECES.COM",
  "acc.changePwd": "Cambiar la contraseña",
  "acc.deleteOpen": "Deseo eliminar mi cuenta",
  "acc.confirmYourPwd": "Confirme su contraseña",
  "acc.addrLabel": "Etiqueta (Casa, Taller…)",
  "acc.addrLabelPh": "Casa",
  "acc.myAddresses": "Mis direcciones ({n}/10)",
  "acc.addAddress": "Añadir una dirección",
  "acc.noAddress": "Ninguna dirección registrada por ahora.",
  "acc.shipDefault": "Envío por defecto",
  "acc.setShipping": "Definir para el envío",
  "acc.billDefault": "Facturación por defecto",
  "acc.setBilling": "Definir para la facturación",
  "acc.holder": "Titular *",
  "acc.savedCards": "Tarjetas registradas ({n}/5)",
  "acc.addCard": "Añadir una tarjeta",
  "acc.noCard": "Ninguna tarjeta registrada.",
  "acc.month": "Mes *",
  "acc.year": "Año *",
  "acc.txCredit": "Saldo abonado",
  "acc.txDebit": "Cargo",
  "acc.txOrder": "Utilizado en pedido",
  "acc.txRefund": "Reembolso en saldo",
  "acc.balance": "Saldo disponible",
  "acc.walletUsage": "Utilizable automáticamente al pagar (casilla «Usar mi saldo»).",
  "acc.noTx": "Ningún movimiento por ahora.",
  "acc.proPending": "Solicitud en validación",
  "acc.proRefused": "Solicitud rechazada",
  "acc.resend": "Reenviar la solicitud",
  "acc.requestPro": "Solicitar una cuenta profesional",
  "cat.showResults": "Ver {n} producto(s)",
  "tw.searchTyres": "Buscar neumáticos",
  "tw.tyres": "Neumáticos",
  "tw.searchWheels": "Buscar llantas",
  "tw.wheels": "Llantas",
  "tw.byVehicle": "Por vehículo",
  "tw.vehicle": "Vehículo",
  "tw.title": "Neumáticos, llantas y accesorios",
  "tw.counts": "{t} neumáticos, {w} llantas",
  "tw.defaultTitle": "Neumáticos y llantas",
  "tw.metaTitle": "Neumáticos y llantas de coche — búsqueda por medida o por vehículo",
  "tw.metaDesc": "Encuentre sus neumáticos de verano, invierno y 4 estaciones por medida (205/55 R16) o por vehículo (medidas de origen), y sus llantas de aluminio o chapa por PCD, ET y buje central.",
  "tw.intro": "Busque sus neumáticos por medida exacta (anchura, altura, diámetro, índices), por vehículo (medidas de origen del fabricante) o sus llantas por PCD, ET y buje central. Marcas premium y económicas, envío rápido, montaje posible en centro asociado.",
  "tw.oeSubtitle": "Medidas de origen para {label}",
  "tw.accessoriesTitle": "Accesorios de neumáticos y ruedas",
  "tw.accessoriesSub": "Tornillos, antirrobo, sensores TPMS, cadenas de nieve, gatos y todo el equipamiento de la rueda.",
  "tw.articles": { one: "{n} artículo", other: "{n} artículos" },
  "tw.comingSoon": "Próximamente",
  "tw.popularSizes": "Medidas más habituales",
  "tw.allSeasons": "Neumáticos para todas las estaciones",
  "tw.brands": "Marcas de neumáticos y llantas",
  "tw.guideTitle": "{k}: la guía OTOPIECES",
  "tw.about": "Acerca de: {n}",
  "tw.faqTitle": "Preguntas frecuentes: {n}",
  "tw.summer": "Verano",
  "tw.winter": "Invierno",
  "tw.fourSeasons": "4 estaciones",
  "tw.vt.voiture": "Turismo",
  "tw.vt.suv": "4x4 / SUV",
  "tw.vt.utilitaire": "Furgoneta",
  "tw.vt.4x4": "4x4",
  "tw.quickSearch": "Búsqueda rápida por medida",
  "tw.quickSearchEx": "— ej. 205 / 55 R16 91V",
  "tw.howToRead": "¿Cómo leer mi neumático?",
  "tw.width": "Anchura",
  "tw.height": "Altura",
  "tw.diameter": "Diámetro",
  "tw.loadIndex": "Índice de carga",
  "tw.speedIndex": "Índice de velocidad",
  "tw.widthPh": "Anchura (ej. 205)",
  "tw.heightPh": "Altura (ej. 55)",
  "tw.diameterPh": "Diámetro (ej. R16)",
  "tw.season": "Estación",
  "tw.advanced": "Seleccionar por parámetros",
  "tw.brand": "Marca",
  "tw.model": "Modelo",
  "tw.allBrands": "Todas las marcas",
  "tw.modelPh": "ej. Primacy, CrossClimate…",
  "tw.homologation": "Homologación (ej. MO, *, AO)",
  "tw.optional": "Opcional",
  "tw.priceMin": "Precio mínimo (€)",
  "tw.priceMax": "Precio máximo (€)",
  "tw.priceMinShort": "Precio mín. (€)",
  "tw.priceMaxShort": "Precio máx. (€)",
  "tw.runflat": "Rodadura sin aire (RunFlat)",
  "tw.runflatHint": "Permite rodar ~80 km a 80 km/h tras un pinchazo",
  "tw.xl": "Reforzado (XL)",
  "tw.xlHint": "Mayor capacidad de carga",
  "tw.ms": "Barro / nieve (M+S)",
  "tw.snowflake": "Agarre en nieve (3PMSF)",
  "tw.studded": "Con clavos",
  "tw.reset": "Restablecer filtros",
  "tw.tyresInCatalog": "{n} neumáticos en catálogo",
  "tw.wheelsInCatalog": "{n} llantas en catálogo",
  "tw.wheelSpecs": "Características de la llanta",
  "tw.wheelSpecsEx": "— ej. 7J x 17 — 5x112 — ET45 — Buje 66,6 mm",
  "tw.widthJ": "Anchura (J)",
  "tw.widthJPh": "Anchura (ej. 7J)",
  "tw.diameterInPh": "Diámetro (ej. 17\")",
  "tw.holes": "Nº de tornillos",
  "tw.holesPh": "Tornillos (ej. 5)",
  "tw.pcd": "PCD",
  "tw.pcdPh": "PCD (ej. 112)",
  "tw.et": "ET (offset)",
  "tw.etPh": "ET (ej. ET45)",
  "tw.centerBore": "Buje central",
  "tw.centerBorePh": "Buje (ej. 66,6)",
  "tw.material": "Material",
  "tw.type": "Tipo",
  "tw.color": "Color / acabado",
  "tw.allF": "Todas",
  "tw.allM": "Todos",
  "tw.wheelModelPh": "ej. TZ, Ultraleggera…",
  "tw.mat.aluminium": "Aluminio",
  "tw.mat.acier": "Acero",
  "tw.type.alu": "Llanta de aluminio",
  "tw.type.tole": "Llanta de chapa",
  "tw.type.ete": "Llanta de verano",
  "tw.type.hiver": "Llanta de invierno",
  "tw.outOfStock": "Agotado",
  "tw.leadDays": "En {n} días",
  "tw.inStock": "En stock · envío en 24 h",
  "tw.pcdShort": "PCD",
  "tw.offset": "ET",
  "tw.bore": "Buje",
  "tw.finish": "Acabado",
  "tw.perUnit": "la unidad · {p} € las 4",
  "tw.viewProduct": "Ver el producto",
  "tw.tyresFound": { one: "{n} neumático encontrado", other: "{n} neumáticos encontrados" },
  "tw.wheelsFound": { one: "{n} llanta encontrada", other: "{n} llantas encontradas" },
  "tw.sortPriceAsc": "Precio ascendente",
  "tw.sortPriceDesc": "Precio descendente",
  "tw.sortRating": "Mejor valorados",
  "tw.sortBrand": "Marca A→Z",
  "tw.noResults": "Sin resultados para estos criterios",
  "tw.noResultsHint": "Amplíe la búsqueda: quite un índice o una opción.",
  "tw.eu.title": "Etiqueta UE",
  "tw.eu.fuel": "Combustible",
  "tw.eu.wet": "Suelo mojado",
  "tw.eu.noise": "Ruido",
  "tw.eu.onlyA": "Solo A",
  "tw.eu.aTo": "A a {g}",
  "tw.eu.noiseA": "≤ 68 dB (clase A)",
  "tw.eu.noiseB": "≤ 71 dB (clase B)",
  "tw.eu.noise75": "≤ 75 dB",
  "tw.eu.snowflake": "3PMSF (Ley de Montaña)",
  "tw.vs.pickAtLeast": "Elija al menos una marca y un modelo",
  "tw.vs.notFound": "Vehículo no encontrado",
  "tw.vs.select": "Seleccione su vehículo",
  "tw.vs.selectSub": "— mostramos las medidas de neumáticos y llantas montadas de origen",
  "tw.vs.showOE": "Ver las medidas de origen",
  "tw.vs.reset": "Restablecer",
  "tw.vs.searching": "Buscando las medidas del fabricante para {v}… (hasta 30 s la primera vez)",
  "tw.vf.tyresAvail": { one: "{n} neumático disponible", other: "{n} neumáticos disponibles" },
  "tw.vf.wheelsAvail": { one: "{n} llanta disponible", other: "{n} llantas disponibles" },
  "tw.vf.none": "Ningún artículo por ahora",
  "tw.vf.notFound": "Medidas de origen no disponibles para {v}",
  "tw.vf.notFoundHint": "Lea la medida inscrita en el flanco de su neumático (ej. 205/55 R16 91V) y use la búsqueda por medida.",
  "tw.vf.switch": "Buscar por medida →",
  "tw.vf.oeFor": "Medidas de origen del fabricante para",
  "tw.vf.aiNotice": "Medidas generadas automáticamente a partir de datos del fabricante y pendientes de verificación por nuestro equipo. Antes de pedir, confirme la medida inscrita en el flanco de su neumático actual.",
  "tw.vf.oeTyres": "Neumáticos de origen",
  "tw.vf.oeWheels": "Llantas de origen",
  "tw.vf.thread": "Rosca",
  "tw.vf.diameters": "Diámetros",
  "tw.vf.seeTyres": "Ver los neumáticos compatibles",
  "tw.vf.seeWheels": "Ver las llantas compatibles",
  "tw.vf.in": "en {s}",
  "tw.vc.year": "Año",
  "tw.vc.engine": "Motorización",
  "tw.vc.pickBrand": "Elegir una marca",
  "tw.vc.pickModel": "Elegir un modelo",
  "tw.vc.selBrand": "Seleccione una marca",
  "tw.vc.pickYear": "Elegir el año",
  "tw.vc.selModel": "Seleccione un modelo",
  "tw.vc.allEngines": "Todas las motorizaciones",
  "tw.vc.selYear": "Seleccione el año",
  "tw.vc.hp": "CV",
  "tw.sg.title": "¿Cómo leer la medida de sus neumáticos?",
  "tw.sg.sub": "Todo está inscrito en el flanco del neumático. Pase el cursor o toque cada elemento del ejemplo",
  "tw.sg.width": "Anchura",
  "tw.sg.widthDesc": "Anchura del neumático en milímetros, medida de flanco a flanco (aquí 205 mm).",
  "tw.sg.height": "Altura (serie)",
  "tw.sg.heightDesc": "Altura del flanco en % de la anchura: 55 % de 205 mm ≈ 113 mm. Cuanto menor es la cifra, más bajo es el perfil.",
  "tw.sg.radial": "Estructura",
  "tw.sg.radialDesc": "R = estructura radial, la norma en todos los coches modernos.",
  "tw.sg.diameter": "Diámetro de llanta",
  "tw.sg.diameterDesc": "Diámetro interior del neumático = diámetro de su llanta, en pulgadas (16\" ≈ 40,6 cm).",
  "tw.sg.load": "Índice de carga",
  "tw.sg.loadDesc": "Carga máxima por neumático: 91 = 615 kg. Nunca baje del índice recomendado por el fabricante.",
  "tw.sg.speed": "Índice de velocidad",
  "tw.sg.speedDesc": "Velocidad máxima autorizada: T 190 km/h · H 210 · V 240 · W 270 · Y 300. Un neumático de invierno puede tener un índice inferior (mín. H en Francia si ≥ velocidad máx. del vehículo − 1 categoría).",
  "tw.sg.where": "¿Dónde encontrar la información?",
  "tw.sg.whereText": "En el flanco del neumático actual, en la etiqueta del marco de la puerta del conductor, en la tapa del depósito o en el libro de mantenimiento. También puede usar la pestaña",
  "tw.sg.whereEnd": "para encontrar las medidas de origen.",
  "auth.loginTitle": "Iniciar sesión",
  "auth.loginSub": "Acceda a su cuenta OTOPIECES.COM",
  "auth.sessionExpired": "Su sesión ha caducado. Vuelva a iniciar sesión.",
  "auth.email": "Email",
  "auth.password": "Contraseña",
  "auth.emailPh": "su@email.com",
  "auth.passwordPh": "Su contraseña",
  "auth.remember": "Mantener la sesión iniciada",
  "auth.rememberDays": "(30 días)",
  "auth.forgot": "¿Ha olvidado su contraseña?",
  "auth.loggingIn": "Conectando...",
  "auth.login": "Iniciar sesión",
  "auth.noAccount": "¿Aún no tiene cuenta?",
  "auth.createAccount": "Crear una cuenta",
  "auth.emailRequired": "Email obligatorio",
  "auth.passwordRequired": "Contraseña obligatoria",
  "auth.badCredentials": "Email o contraseña incorrectos",
  "auth.registerSub": "Cree su cuenta para seguir sus pedidos y guardar sus vehículos",
  "auth.firstName": "Nombre",
  "auth.lastName": "Apellidos",
  "auth.firstNamePh": "Juan",
  "auth.lastNamePh": "García",
  "auth.emailPh2": "juan.garcia@email.com",
  "auth.phone": "Teléfono (opcional)",
  "auth.phonePh": "612 34 56 78",
  "auth.min8": "Mínimo 8 caracteres",
  "auth.confirmPassword": "Confirmar la contraseña",
  "auth.repeatPh": "Repita la contraseña",
  "auth.acceptPrefix": "Acepto las",
  "auth.terms": "condiciones generales",
  "auth.and": "y la",
  "auth.privacy": "política de privacidad",
  "auth.newsletter": "Deseo recibir ofertas y promociones por email",
  "auth.sessionHint": "Permanecerá conectado durante 30 días en este dispositivo.",
  "auth.creating": "Creando la cuenta...",
  "auth.createMine": "Crear mi cuenta",
  "auth.haveAccount": "¿Ya tiene una cuenta?",
  "auth.firstNameRequired": "Nombre obligatorio",
  "auth.lastNameRequired": "Apellidos obligatorios",
  "auth.emailInvalid": "Email no válido",
  "auth.passwordsMismatch": "Las contraseñas no coinciden",
  "auth.acceptRequired": "Debe aceptar las condiciones",
  "auth.registerError": "Error al registrarse",
  "auth.forgotTitle": "Contraseña olvidada",
  "auth.forgotMeta": "Restablezca la contraseña de su cuenta OTOPIECES.COM.",
  "auth.forgotIntro": "Indique su dirección de email: le enviaremos un enlace para elegir una nueva contraseña.",
  "auth.checkInbox": "Revise su bandeja de entrada",
  "auth.sentBefore": "Si existe una cuenta con la dirección",
  "auth.sentAfter": ", se acaba de enviar un email con un enlace de restablecimiento (válido 1 hora).",
  "auth.spam": "Revise también su carpeta de correo no deseado.",
  "auth.backLogin": "Volver al inicio de sesión",
  "auth.emailAddress": "Dirección de email",
  "auth.sendLink": "Enviar el enlace de restablecimiento",
  "auth.emailAddressInvalid": "Dirección de email no válida",
  "auth.genericError": "Se ha producido un error, inténtelo de nuevo en un momento",
  "auth.resetTitle": "Nueva contraseña",
  "auth.resetMeta": "Elija una nueva contraseña para su cuenta OTOPIECES.COM.",
  "auth.account": "Cuenta:",
  "auth.linkIncomplete": "Enlace incompleto: abra el enlace recibido por email.",
  "auth.linkInvalid": "Enlace no válido o caducado",
  "auth.requestNew": "Solicitar un nuevo enlace",
  "auth.changed": "¡Contraseña modificada!",
  "auth.redirecting": "Ya ha iniciado sesión. Redirigiendo…",
  "auth.newPassword": "Nueva contraseña",
  "auth.min8Ph": "8 caracteres como mínimo",
  "auth.saveNew": "Guardar la nueva contraseña",
  "auth.min8Long": "La contraseña debe contener al menos 8 caracteres",
  "auth.cannotChange": "No se ha podido modificar la contraseña",
  "auth.tooMany": "Demasiadas solicitudes. Inténtelo de nuevo en 15 minutos.",
  "auth.linkInvalidDetail": "Este enlace de restablecimiento no es válido o ha caducado. Solicite uno nuevo.",
  "common.loading": "Cargando…",
  "search.parts": "Piezas {b}",
  "search.metaQuery": "Búsqueda « {q} »",
  "search.metaDefault": "Búsqueda de piezas",
  "search.metaDesc": "Resultados de búsqueda para {q} en OTOPIECES.COM: {n} producto(s) encontrado(s).",
  "search.brandPage": "Ver la página de la marca",
  "search.resultsFor": "Resultados para « {q} »",
  "search.title": "Búsqueda",
  "search.noMatch": "Ningún producto coincide con « {q} »",
  "search.hint": "Introduzca una palabra clave, una marca o una referencia",
  "search.showUnfiltered": "Ver los {n} resultados sin filtrar por vehículo",
  "brands.metaTitle": "Todas las marcas de piezas de automóvil de la A a la Z",
  "brands.metaDesc": "Descubra las {n} marcas de recambios disponibles en OTOPIECES.COM{list}. Calidad original y garantía de 2 años.",
  "brands.all": "Todas las marcas",
  "brands.countAZ": { one: "{n} marca de recambios, ordenada de la A a la Z", other: "{n} marcas de recambios, ordenadas de la A a la Z" },
  "brands.searchPh": "Buscar una marca…",
  "brands.noMatch": "Ninguna marca coincide con « {q} ».",
  "search.nearTitle": "Quizá quiso decir… referencias cercanas",
  "search.nearVia": "vía ref.",
  "partRequest.cta": "Solicitar esta pieza",
  "partRequest.ctaHint": "Buscamos la pieza con nuestros proveedores y le respondemos por correo en 24 h laborables.",
  "partRequest.title": "Solicitar esta pieza",
  "partRequest.intro": "Déjenos sus datos: nuestro equipo comprueba disponibilidad y precio y le responde por correo.",
  "partRequest.msgSearch": "Pieza buscada",
  "partRequest.msgVehicle": "Vehículo",
  "partRequest.msgDetails": "Detalles",
  "partRequest.detailsPh": "Detalles útiles: referencia OEM, lado (izquierdo/derecho), año, foto de la pieza…",
  "partRequest.submit": "Enviar mi solicitud",
  "partRequest.sent": "¡Solicitud enviada!",
  "partRequest.sentDesc": "Le hemos enviado un acuse de recibo por correo; le responderemos en breve.",
  "cat.topRated": "4 ★ o más",
  "cat.topRatedTitle": "Mostrar solo las piezas valoradas con 4/5 o más por nuestros clientes",
  "brands.sortBy": "Ordenar:",
  "brands.sortAz": "A → Z",
  "brands.sortTrust": "Índice de confianza",
  "brands.noReviews": "Sin opiniones aún",
  "brands.trustHint": { one: "{n} marca valorada por nuestros clientes — las mejor valoradas primero, luego las marcas sin opiniones por orden alfabético.", other: "{n} marcas valoradas por nuestros clientes — las mejor valoradas primero, luego las marcas sin opiniones por orden alfabético." },
  "brand.notFound": "Marca no encontrada",
  "brand.metaCat": "{c} {b} — Piezas de automóvil",
  "brand.metaTitle": "Piezas {b} — Catálogo y precios",
  "brand.metaDesc": "Todas las piezas {b}: {n} producto(s) en {cats}. Calidad original, garantía de 2 años, envío rápido en Francia.",
  "brand.noProducts": "No hay ningún producto « {b} » en nuestro catálogo.",
  "brand.eyebrow": "Marca de piezas",
  "brand.products": { one: "{n} producto", other: "{n} productos" },
  "brand.categories": { one: "{n} categoría", other: "{n} categorías" },
  "cmp.title": "Comparación de productos",
  "cmp.addFailed": "No se puede añadir",
  "cmp.price": "Precio con IVA",
  "cmp.oldPrice": "Precio tachado",
  "cmp.discount": "Descuento",
  "cmp.rating": "Valoración de clientes",
  "cmp.availability": "Disponibilidad",
  "cmp.inStock": "En stock",
  "cmp.outOfStock": "Agotado",
  "cmp.ref": "Referencia",
  "cmp.subcategory": "Subcategoría",
  "cmp.soldBy": "Vendido por",
  "cmp.pack": "lote",
  "cmp.packs": "Formatos",
  "cmp.warranty": "Garantía",
  "cmp.twoYears": "2 años",
  "cmp.compat": "Compatibilidad",
  "cmp.universal": "Universal",
  "cmp.intro": "{n}/{max} productos · añada piezas de una misma categoría desde las fichas de producto (icono balanza).",
  "cmp.clear": "Vaciar el comparador",
  "cmp.empty": "Su comparador está vacío",
  "cmp.emptyHint": "Explore el catálogo y haga clic en el icono balanza para comparar hasta {max} piezas.",
  "cmp.browse": "Ver las piezas",
  "cmp.remove": "Quitar",
  "nf.metaTitle": "Página no encontrada (404)",
  "nf.title": "Esta pieza no está en el catálogo…",
  "nf.text": "La página solicitada ha sido movida, eliminada o nunca ha existido. No se preocupe: el camino correcto está justo debajo.",
  "nf.searchPh": "Buscar una pieza, una referencia, una marca…",
  "nf.search": "Buscar",
  "nf.topCategories": "Categorías más buscadas",
  "wl.guestBefore": "Su lista se guarda en este dispositivo.",
  "wl.guestLogin": "Inicie sesión",
  "wl.guestAfter": "para encontrarla en cualquier lugar y conservarla.",
  "chat.tooShort": "Describa su solicitud en unas pocas palabras (mínimo 10 caracteres).",
  "chat.failed": "No se ha podido enviar, inténtelo de nuevo.",
  "chat.open": "Contactar con atención al cliente",
  "chat.greeting": "¡Hola! Haga su pregunta, un asesor le responderá por e-mail.",
  "chat.another": "Enviar otro mensaje",
  "chat.sent": "¡Mensaje enviado!",
  "chat.replyTime": "Respuesta por e-mail en un plazo de 24 h laborables",
  "chat.reference": "Referencia",
  "chat.messagePh": "Escriba su mensaje...",
  "chat.emailPh": "Su e-mail",
  "chat.namePh": "Su nombre",
  "contact.sent": "Mensaje enviado",
  "contact.failed": "No se ha podido enviar",
  "contact.address": "Dirección",
  "contact.phoneWa": "Teléfono / WhatsApp",
  "contact.hours": "Horario",
  "contact.metaDesc": "Contacte con el servicio de atención al cliente de OTOPIECES.COM: teléfono, e-mail, formulario. Respuesta en un plazo de 24 h laborables.",
  "contact.heading": "¿Una pregunta? Le respondemos.",
  "contact.intro": "Compatibilidad de una pieza, seguimiento de pedido, devolución o factura: nuestro equipo de apasionados del automóvil está aquí para ayudarle.",
  "contact.tracking": "Seguimiento",
  "contact.returns": "Devoluciones",
  "contact.writeUs": "Escríbanos",
  "contact.ackSent": "Se le ha enviado un acuse de recibo por e-mail; le respondemos en un plazo de 24 h laborables.",
  "contact.message": "Mensaje",
  "contact.received": "¡Mensaje recibido correctamente!",
  "contact.fullName": "Nombre completo",
  "contact.newMessage": "Nuevo mensaje",
  "contact.orderNo": "N.º de pedido (opcional)",
  "contact.subject": "Asunto",
  "contact.phone": "Teléfono",
  "contact.privacyNote": "Sus datos se utilizan únicamente para tramitar su solicitud.",
  "contact.messagePh": "Describa su solicitud (vehículo, referencia de la pieza, problema encontrado…)",
  "contact.details": "Nuestros datos de contacto",
  "contact.send": "Enviar",
  "chat.page": "Página:",
  "chat.send": "Enviar",
  "orders.invoicePdf": "Factura PDF",
  "cat.all": "Todas",
  "cat.filterSubs": "Filtrar las {n} subcategorías…",
  "cat.noSubMatch": "Ninguna subcategoría coincide con « {q} »",
  "cat.otherSubs": "Otras subcategorías {name}",
  "cat.subsubs": "Subcategorías de {name}",
  "xsell.badge": "Complemento útil",
  "xsell.compatible": "Compatible con su vehículo",
  "xsell.addedTitle": "Añadido al carrito",
  "xsell.completeTitle": "Complete su compra",
  "xsell.completeHint": "Lo imprescindible para la intervención — usted elige.",
  "xsell.continue": "Seguir comprando",
  "xsell.cartTitle": "Lo imprescindible para su mantenimiento",
  "xsell.cartHint": "Productos complementarios útiles para las piezas de su carrito.",
  "xsell.productTitle": "Productos complementarios",
  "xsell.productHint": "A menudo necesarios para esta intervención.",
  "cat.quickFilters": "Filtros rápidos",
  "cat.quickFiltersHint": "Elige una subcategoría de {name} y una marca: la pieza correcta en dos clics.",
  "cat.nProducts": { one: "{n} producto", other: "{n} productos" },
  "banner.discover": "Descubrir",
  "banner.prev": "Banner anterior",
  "banner.next": "Banner siguiente",
  "banner.n": "Banner {n}",
  "about.title": "Quiénes somos",
  "about.eyebrow": "Acerca de",
  "about.heading": "{name}, la pieza de auto sin complicaciones",
  "about.intro": "Nacida de la frustración de no encontrar nunca la referencia correcta, nuestra tienda reúne catálogo del fabricante, asesoramiento de expertos y entrega exprés.",
  "about.description": "{name}: el especialista francés en recambios de automóvil online. Nuestra historia, nuestros valores, nuestro equipo.",
  "about.kpiRefs": "referencias en stock",
  "about.kpiMakers": "fabricantes de equipo original",
  "about.kpiBrands": "marcas de vehículos",
  "about.kpiShip": "plazo de envío",
  "about.kpiShipValue": "24 h",
  "about.storyTitle": "Nuestra historia",
  "about.story1": "Todo empieza en un taller independiente: demasiado tiempo perdido buscando una referencia, demasiados errores de compatibilidad, demasiados plazos. Decidimos construir la herramienta que nos habría gustado tener: un catálogo exacto por motorización, precios de fabricante y una entrega que cumple lo prometido.",
  "about.story2": "Hoy, particulares y profesionales piden en {name} piezas de frenado, filtración, distribución, suspensión o carrocería de las principales marcas — TRW, Bosch, Brembo, Valeo, Mann-Filter, LuK… — con la garantía de la pieza correcta, al precio justo.",
  "about.promiseLabel": "Nuestra promesa",
  "about.promise": "« La pieza correcta, entregada rápido, al precio justo — y una persona al teléfono si hace falta. »",
  "about.valuesTitle": "Nuestros valores",
  "about.v1Title": "La pieza adecuada, a la primera",
  "about.v1Text": "Compatibilidad verificada por motorización exacta y búsqueda por matrícula: cero error de referencia.",
  "about.v2Title": "El precio justo",
  "about.v2Text": "Compra directa a los fabricantes de equipo original, precios decrecientes y tarifas profesionales transparentes.",
  "about.v3Title": "Entrega rápida y correcta",
  "about.v3Text": "Envío en 24 h, transportistas asociados y seguimiento en tiempo real hasta su puerta.",
  "about.v4Title": "Responsable",
  "about.v4Text": "Embalajes reciclados, reacondicionamiento de devoluciones y socios certificados.",
  "about.teamTitle": "El equipo",
  "about.t1Name": "Atención al cliente",
  "about.t1Role": "Respuesta en 24 h laborables",
  "about.t2Name": "Expertos técnicos",
  "about.t2Role": "Mecánicos y chapistas",
  "about.t3Name": "Logística",
  "about.t3Role": "Preparación y envío",
  "about.t4Name": "Compras",
  "about.t4Role": "Selección de fabricantes",
  "about.joinTitle": "¿Desea unirse a nosotros o trabajar con nosotros?",
  "about.joinText": "Empleo, colaboraciones, prensa: hablemos.",
  "about.careers": "Empleo",
  "about.contact": "Contáctenos",
  "ret.title": "Garantía y devoluciones",
  "ret.description": "Devolución en 14 días, garantía de 2 años en todas las piezas OTOPIECES.COM. Procedimiento de devolución en 4 pasos.",
  "ret.heading": "Satisfecho o reembolsado, garantía de 2 años",
  "ret.intro": "¿Un error de referencia, una pieza que no encaja? La devolución es sencilla y el reembolso rápido.",
  "ret.k1": "14 días",
  "ret.k1Text": "para cambiar de opinión",
  "ret.k2": "2 años",
  "ret.k2Text": "de garantía del fabricante",
  "ret.k3": "5 días",
  "ret.k3Text": "para ser reembolsado",
  "ret.stepsTitle": "Devolver una pieza en 4 pasos",
  "ret.s1Title": "Declare la devolución",
  "ret.s1Text": "Desde « Mis pedidos », cancele o contáctenos indicando el número de pedido y la pieza en cuestión.",
  "ret.s2Title": "Embalaje la pieza",
  "ret.s2Text": "Pieza no montada, en su embalaje original con la factura. Le enviamos la etiqueta de devolución.",
  "ret.s3Title": "Deposite el paquete",
  "ret.s3Text": "En oficina de correos o punto de recogida en un plazo de 14 días. El seguimiento nos informa de la recepción.",
  "ret.s4Title": "Reembolso",
  "ret.s4Text": "En un plazo de 5 días tras el control: en su método de pago o en crédito inmediato en su cuenta de depósito.",
  "ret.coveredTitle": "Cubierto por la garantía",
  "ret.covered1": "Defecto de fabricación o de material",
  "ret.covered2": "Pieza no conforme con la referencia pedida",
  "ret.covered3": "Rotura o pieza faltante en la entrega",
  "ret.covered4": "Avería prematura en condiciones normales de uso",
  "ret.notCoveredTitle": "No cubierto",
  "ret.notCovered1": "Pieza montada, usada o modificada",
  "ret.notCovered2": "Desgaste normal (pastillas, discos, filtros… )",
  "ret.notCovered3": "Montaje no conforme con las recomendaciones del fabricante",
  "ret.notCovered4": "Devolución fuera del plazo de 14 días o sin embalaje original",
  "ret.ctaTitle": "¿Listo para devolver una pieza?",
  "ret.ctaText": "Vaya a sus pedidos para cancelar o solicitar una devolución, o contacte con nuestro servicio de atención al cliente.",
  "ret.ctaOrders": "Solicitar una devolución",
  "ret.ctaContact": "Contactarnos",
  "sm.title": "Mapa del sitio",
  "sm.description": "Todas las páginas de OTOPIECES.COM: categorías de piezas, marcas, espacio cliente, información.",
  "sm.eyebrow": "Navegación",
  "sm.intro": "Encuentre de un vistazo todas las secciones de la tienda.",
  "sm.shop": "Tienda",
  "sm.account": "Mi cuenta",
  "sm.help": "Ayuda",
  "sm.home": "Inicio",
  "sm.allParts": "Todas las piezas",
  "sm.brandsAZ": "Marcas de la A a la Z",
  "sm.guides": "Guías y consejos",
  "sm.compare": "Comparador",
  "sm.cart": "Carrito",
  "sm.myOto": "Mi OTOPIECES",
  "sm.garage": "Mi garaje",
  "sm.pro": "Cuenta profesional",
  "sm.orders": "Mis pedidos",
  "sm.wishlist": "Mi lista de deseos",
  "sm.addresses": "Libreta de direcciones",
  "sm.bank": "Datos bancarios",
  "sm.wallet": "Cuenta de depósito",
  "sm.settings": "Configuración",
  "sm.login": "Inicio de sesión",
  "sm.register": "Registro",
  "sm.contact": "Contacto",
  "sm.shipping": "Entrega y seguimiento",
  "sm.returns": "Garantía y devoluciones",
  "sm.about": "Quiénes somos",
  "sm.sitemap": "Mapa del sitio",
  "sm.categories": "Categorías de piezas",
  "sm.vehicleBrands": "Marcas de vehículos",
  "sm.makers": "Fabricantes",
  "sm.pages": "Información y páginas legales",
  "garage.title": "Mis vehículos",
  "garage.add": "Añadir un vehículo",
  "garage.intro": "Registre sus vehículos para encontrar en un clic las piezas compatibles. Al añadir su matrícula, será reconocida por la búsqueda por matrícula tras la validación de nuestro equipo.",
  "garage.selectRequired": "Seleccione la marca, el modelo y el año",
  "garage.addedPlate": "Vehículo añadido — su matrícula será reconocida por la búsqueda por matrícula tras la validación de nuestro equipo",
  "garage.added": "Vehículo añadido",
  "garage.addError": "Error al añadir el vehículo",
  "garage.confirmDelete": "¿Eliminar {name}?",
  "garage.deleted": "Vehículo eliminado",
  "garage.newVehicle": "Vehículo nuevo",
  "garage.brand": "Marca *",
  "garage.model": "Modelo *",
  "garage.year": "Año *",
  "garage.engine": "Motorización",
  "garage.hp": "cv",
  "garage.platePh": "Matrícula (opcional) — AA-123-BB",
  "garage.labelPh": "Apodo (opcional) — p. ej.: Coche de María",
  "garage.cancel": "Cancelar",
  "garage.save": "Guardar",
  "garage.empty": "No hay ningún vehículo registrado por el momento.",
  "garage.plateValidated": "Matrícula validada",
  "garage.plateRefused": "Matrícula rechazada",
  "garage.platePending": "Matrícula pendiente de validación",
  "garage.useSelected": "Vehículo seleccionado · Ver las piezas",
  "garage.use": "Usar este vehículo",
  "garage.delete": "Eliminar",
  "mb.mileage": "Kilometraje actual",
  "mb.mileagePh": "p. ej. 85000",
  "mb.yearly": "Km / año (estimación)",
  "mb.save": "Guardar",
  "mb.overdueKm": "superado en {n} km",
  "mb.inKm": "en {n} km",
  "mb.overdueDays": "superado en {n} d",
  "mb.inDays": "en {n} d",
  "mb.lastPurchase": "última compra {date}",
  "mb.seeParts": "Ver las piezas",
  "mb.noVehicle1": "Añada un vehículo en",
  "mb.noVehicleLink": "Mi garaje",
  "mb.noVehicle2": "para activar su cuaderno de mantenimiento predictivo.",
  "mb.estimated": "estimados hoy",
  "mb.enterMileage": "Indique su kilometraje para recibir sus vencimientos de mantenimiento (distribución, frenos, filtros…).",
  "mb.alertsTitle": "Alertas enviadas",
  "mb.see": "Ver",
  "mb.diagTitle": "Mis verificaciones por foto",
  "mb.diagEmpty": "Ninguna solicitud. El botón «Verificar mi pieza por foto» está disponible en las fichas de producto técnicas.",
  "mb.partToIdentify": "Pieza a identificar",
  "mb.confirmed": "Referencia confirmada",
  "mb.rejected": "No identificada",
  "mb.pending": "Pendiente de validación",
  "mb.ref": "Ref. {ref}",
  "mb.aiLead": "Pista IA: {ref} ({c} %)",
  "mb.seePart": "Ver la pieza",
  "promo.copyCode": "Copiar el código",
  "promo.copied": "¡Código copiado!",
  "winter.myTyres": "Ver mis neumáticos de invierno",
  "winter.seeTyres": "Ver neumáticos de invierno",
  "winter.close": "Cerrar",
  "cat.reset": "Restablecer",
  "cat.resetFilters": "Restablecer filtros",
  "cat.guideTitle": "{kw}: la guía OTOPIECES",
  "cat.aboutTitle": "Acerca de: {name}",
  "cat.faqTitle": "Preguntas frecuentes: {name}",
  "search.seeAll": "Ver todos los resultados de «{q}»",
  "product.refLabel": "Ref.",
  "content.notFound": "Página no encontrada",
  "content.backHome": "Volver al inicio",
  "content.updatedOn": "Actualizado el {date}",
  "blog.title": "Revista OTOPIECES.COM",
  "blog.intro": "Descubre nuestras guías prácticas, consejos de mantenimiento y trucos para cuidar tu vehículo.",
  "blog.searchPh": "Buscar un artículo...",
  "blog.empty": "Ningún artículo encontrado",
  "blog.featured": "Artículo destacado",
  "blog.notFound": "Artículo no encontrado",
  "blog.backToList": "Volver a las guías",
  "blog.readTime": "{time} de lectura",
  "blog.share": "Compartir:",
  "blog.related": "Artículos similares",
  "blog.popular": "Temas populares",
  "blog.catOil": "Aceite de motor",
  "blog.catBrakes": "Frenos",
  "blog.catMaintenance": "Mantenimiento",
  "blog.catElectric": "Eléctrico",
  "blog.nArticles": { "one": "{n} artículo", "other": "{n} artículos" },
  "blog.video1": "¿Cómo ahorrar al comprar piezas de recambio?",
  "blog.video2": "Qué hacer si se enciende el testigo del motor",
  "blog.video3": "TOP 8 errores que cometen los propietarios de coches",
  "frev.l1": "Muy decepcionante",
  "frev.l2": "Decepcionante",
  "frev.l3": "Correcto",
  "frev.l4": "Bien",
  "frev.l5": "Excelente",
  "frev.invalidLink": "Enlace no válido",
  "frev.sendError": "No se pudo enviar",
  "frev.title": "Tu opinión sobre el centro",
  "frev.intro": "Hola {name}, tus {n} neumático(s) se montaron en",
  "frev.on": "el",
  "frev.order": "pedido",
  "frev.thanks": "¡Gracias por tu opinión!",
  "frev.already": "Ya has valorado este centro.",
  "frev.replyFrom": "Respuesta de {author}",
  "frev.backShop": "Volver a la tienda",
  "frev.question": "¿Cómo fue tu cita de montaje?",
  "frev.clickStar": "Haz clic en una estrella",
  "frev.comment": "Tu comentario (opcional)",
  "frev.commentPh": "Recibimiento, puntualidad, calidad del montaje…",
  "frev.submit": "Enviar mi opinión",
  "notif.title": "Notificaciones",
  "notif.empty": "Ninguna notificación por ahora.",
  "notif.maintenanceLink": "Mi libro de mantenimiento",
  "notif.agoMin": "hace {n} min",
  "notif.agoH": "hace {n} h",
  "notif.agoD": "hace {n} d",
  "notif.refConfirmed": "Referencia confirmada para tu pieza",
  "notif.photoRequest": "Tu solicitud de verificación por foto",
  "notif.fittingMoved": "Cita de montaje aplazada",
  "notif.fittingConfirmed": "Cita de montaje confirmada",
  "notif.fittingTomorrow": "Montaje de tus neumáticos mañana",
  "notif.maintenance": "Mantenimiento previsto: {sub} ({vehicle})",
  "notif.k.diag_auto.title": "Referencia confirmada para su pieza",
  "notif.k.diag_auto.body": "Referencia {ref} ({brand}) confirmada por análisis de foto: {explanation}",
  "notif.k.diag_rejected.title": "Su solicitud de verificación por foto",
  "notif.k.diag_rejected.body": "{message}",
  "notif.k.diag_rejected_default.title": "Su solicitud de verificación por foto",
  "notif.k.diag_rejected_default.body": "No hemos podido identificar la pieza en su foto. Inténtelo de nuevo con una foto más nítida o contacte con nuestro servicio de atención al cliente.",
  "notif.k.diag_admin.title": "Referencia confirmada para su pieza",
  "notif.k.diag_admin.body": "Nuestro equipo ha verificado su foto: la referencia a pedir es {ref}{brand_suffix}. {message}",
  "notif.k.maintenance_km.title": "Mantenimiento previsto: {sub} ({vehicle})",
  "notif.k.maintenance_km.body": "Según su kilometraje, su {sub} vence en unos {km} km. Aquí están las piezas compatibles con su {vehicle}.",
  "notif.k.maintenance_now.title": "Mantenimiento previsto: {sub} ({vehicle})",
  "notif.k.maintenance_now.body": "Según su kilometraje, su {sub} vence desde ahora. Aquí están las piezas compatibles con su {vehicle}.",
  "notif.k.maintenance_days.title": "Mantenimiento previsto: {sub} ({vehicle})",
  "notif.k.maintenance_days.body": "Según su kilometraje, su {sub} vence en {days} días. Aquí están las piezas compatibles con su {vehicle}.",
  "notif.k.fit_confirmed.title": "Cita de montaje confirmada",
  "notif.k.fit_confirmed.body": "{centre} ({city}) confirma el montaje de sus neumáticos el {date} — pedido {order}.",
  "notif.k.fit_confirmed_requested.title": "Cita de montaje confirmada",
  "notif.k.fit_confirmed_requested.body": "{centre} ({city}) confirma el montaje de sus neumáticos el {date} (franja solicitada: {requested}) — pedido {order}.",
  "notif.k.fit_moved.title": "Cita de montaje aplazada",
  "notif.k.fit_moved.body": "{centre} ({city}) ha trasladado su cita al {date} — pedido {order}.",
  "notif.k.fit_reminder.title": "Montaje de sus neumáticos mañana",
  "notif.k.fit_reminder.body": "Recordatorio: cita el {date} en {centre}, {address}.",
  "notif.k.fit_reassigned_kept.title": "Nuevo centro de montaje",
  "notif.k.fit_reassigned_kept.body": "El montaje de sus neumáticos (pedido {order}) ahora lo realiza {centre} — {address}. Su franja del {date} se mantiene, pendiente de confirmación por el centro.",
  "notif.k.fit_reassigned_propose.title": "Nuevo centro de montaje",
  "notif.k.fit_reassigned_propose.body": "El montaje de sus neumáticos (pedido {order}) ahora lo realiza {centre} — {address}. El centro le propondrá una fecha.",
  "notif.k.fit_review_reply.title": "El centro ha respondido a su opinión",
  "notif.k.fit_review_reply.body": "{centre}: «{excerpt}»",
  "notif.k.fit_cancelled_credit.title": "Montaje anulado — abono generado",
  "notif.k.fit_cancelled_credit.body": "Abono {number} de {amount} acreditado en su cuenta de depósito (pedido {order}).",
  "notif.k.fit_card_refund.title": "Abono reembolsado en su medio de pago",
  "notif.k.fit_card_refund.body": "El abono {number} de {amount} se le reembolsa en su {method} (plazo bancario de 3 a 10 días).",
  "acc.notifications": "Notificaciones",
  "notif.seeAll": "Ver todas mis notificaciones",
  "nc.kind.all": "Todas",
  "nc.kind.fitting": "Montaje",
  "nc.kind.diagnostic": "Diagnóstico por foto",
  "nc.kind.maintenance": "Mantenimiento",
  "nc.unreadOnly": "Solo no leídas",
  "nc.readAll": "Marcar todo como leído",
  "nc.prefs": "Preferencias",
  "nc.markRead": "Marcar como leída",
  "nc.markUnread": "Marcar como no leída",
  "nc.delete": "Eliminar",
  "nc.empty": "No hay notificaciones para este filtro.",
  "nc.prev": "Anterior",
  "nc.next": "Siguiente",
  "nc.pageOf": "Página {page} / {pages}",
  "nc.prefsTitle": "Preferencias de notificaciones",
  "nc.prefsIntro": "Elija, para cada tipo de notificación, si desea recibirla también por correo electrónico o solo en la campana del sitio.",
  "nc.emailAndBell": "Correo + campana",
  "nc.bellOnly": "Solo campana",
  "nc.transactionalNote": "Los correos imprescindibles (confirmación de pedido, envío, factura, abono, contraseña) se envían siempre.",
  "nc.ch.diagnostic": "Diagnóstico por foto",
  "nc.chDesc.diagnostic": "Referencia confirmada o solicitud de verificación tratada por nuestro equipo.",
  "nc.ch.maintenance": "Mantenimiento previsto",
  "nc.chDesc.maintenance": "Recordatorios de mantenimiento según el kilometraje de sus vehículos.",
  "nc.ch.fitting": "Montaje de neumáticos",
  "nc.chDesc.fitting": "Cita confirmada o cambiada, recordatorio del día anterior, cambio de centro.",
  "nc.ch.reviews": "Opiniones y respuestas",
  "nc.chDesc.reviews": "Invitaciones a dejar su opinión y respuestas del centro o de nuestro equipo a sus opiniones.",
  "nc.ch.alerts": "Alertas de precio, lista de deseos y preguntas",
  "nc.chDesc.alerts": "Bajada de precio o reposición de un artículo seguido, respuesta a sus preguntas sobre productos.",
  "ps.title": "Espacio del centro asociado",
  "ps.invalidLink": "Enlace no válido",
  "ps.savedSchedule": "Horarios guardados: los clientes ya pueden reservar una franja con usted.",
  "ps.saveFailed": "No se pudo guardar",
  "ps.savedLang": "Idioma guardado: {lang}.",
  "ps.langFailed": "Idioma no guardado",
  "ps.perTyre": "/ neumático",
  "ps.langHint": "Idioma de este espacio y de los correos que le enviamos",
  "ps.langLabel": "Idioma",
  "ps.slotsTitle": "Mis franjas de montaje",
  "ps.slotsIntro": "Indique sus horarios de apertura por día: los clientes elegirán una franja libre al pedir y recibirá un correo para confirmarla.",
  "ps.upcomingTitle": "Próximas citas",
  "ps.noUpcoming": "No hay citas próximas.",
  "ps.nTyres": "{n} neumático(s)",
  "ps.toConfirm": "Por confirmar",
  "ps.confirmed": "Confirmada",
  "ps.confirm": "Confirmar",
  "ps.edit": "Modificar",
  "ps.reviewsTitle": "Opiniones de mis clientes",
  "ps.reviewsIntro": "Sus respuestas son públicas (visibles para los clientes al elegir un centro); el cliente recibe un correo con su primera respuesta.",
  "ps.noReviews": "Aún no hay opiniones.",
  "ps.slotDuration": "Duración de la franja",
  "ps.leadDays": "Plazo mínimo (días, recepción de neumáticos)",
  "ps.capacity": "Vehículos por franja",
  "ps.weekPreset": "Semana tipo (Lun–Vie 8–12 / 14–18, Sáb 9–12)",
  "ps.addRange": "franja",
  "ps.closed": "Cerrado",
  "ps.rangeError": "Cada franja debe terminar después de su inicio.",
  "ps.saveSchedule": "Guardar horarios",
  "ps.ofScore": "{n} % de la puntuación",
  "ps.noDelay": "Aún no se ha medido ninguna confirmación",
  "ps.delayUnderHour": "Plazo medio de confirmación: menos de una hora",
  "ps.delayAvg": "Plazo medio de confirmación: {d} (100 si ≤ 12 h, 0 más de 96 h)",
  "ps.dayShort": "d",
  "ps.relTitle": "Mi fiabilidad",
  "ps.relWindow": "en los últimos {n} días, actualizado en tiempo real",
  "ps.relIntro": "Los clientes ven primero los centros más fiables. Una puntuación «A vigilar» (menos de 40) en al menos {n} pedidos oculta temporalmente el centro al pedir.",
  "ps.visible": "Propuesto a los clientes",
  "ps.hidden": "Oculto en el pago",
  "ps.since": "desde el {d}",
  "ps.relEmpty": "Aún no hay pedidos en el periodo: su puntuación aparecerá tras el primer montaje.",
  "ps.barConfirmed": "Citas confirmadas",
  "ps.confirmedOf": "{c} confirmada(s) de {o} pedido(s)",
  "ps.pendingN": "{n} pendiente(s) de su confirmación",
  "ps.barDelay": "Rapidez de respuesta",
  "ps.barKept": "Pedidos conservados",
  "ps.reassignedN": "{n} pedido(s) reasignado(s) a otro centro por falta de respuesta",
  "ps.noReassigned": "Ningún pedido reasignado — perfecto",
  "ps.pointsTitle": "Puntos a mejorar",
  "ps.keepGoing": "Siga así",
  "ps.excellent": "Puntuación excelente: aparece en cabeza de lista para los clientes cercanos.",
  "ps.ratingLine": "Valoración: {avg}/5 en {count} opiniones · {upcoming} citas próximas.",
  "ps.histEmpty": "Historial disponible desde la primera semana con pedidos.",
  "ps.histTitle": "Evolución de la puntuación en {n} semanas",
  "ps.calTitle": "Añadir mis citas a mi agenda",
  "ps.calIntro": "Suscriba su agenda a este enlace: los montajes (confirmados y pendientes) aparecen automáticamente en Google Calendar, Outlook o Apple Calendar, actualizados cada hora.",
  "ps.copied": "Copiado",
  "ps.copyLink": "Copiar enlace",
  "ps.subscribe": "Suscribirse (Apple / Outlook)",
  "ps.downloadIcs": "Descargar .ics",
  "ps.calGoogle": "Otros calendarios (+) → «Desde URL» → pegue el enlace.",
  "ps.calOutlook": "Agregar calendario → «Suscribirse desde la web» → pegue el enlace.",
  "ps.calApple": "Archivo → Nueva suscripción a calendario, o haga clic en «Suscribirse».",
  "ps.sendFailed": "No se pudo enviar",
  "ps.deleteReplyConfirm": "¿Eliminar su respuesta?",
  "ps.editReply": "Modificar mi respuesta",
  "ps.reply": "Responder",
  "ps.replyPlaceholder": "Gracias por su comentario…",
  "ps.publicReply": "respuesta pública",
  "ps.customerNotified": "el cliente recibe un correo",
  "ps.publish": "Publicar",
  "ps.stValidated": "Validado el {d}",
  "ps.stDisputed": "Impugnado el {d} — pendiente de revisión",
  "ps.stResolved": "Impugnación tratada el {d}",
  "ps.actionFailed": "Acción imposible",
  "ps.stFittings": {"one": "{count} montaje", "other": "{count} montajes"},
  "ps.stUpcoming": "{n} próximos",
  "ps.currentMonth": "mes en curso",
  "ps.reason": "Motivo:",
  "ps.answer": "Respuesta:",
  "ps.validateConfirm": "¿Validar el extracto de {m} ({a} IVA incl.)? Esta validación es definitiva.",
  "ps.validate": "Validar extracto",
  "ps.dispute": "Impugnar",
  "ps.disputeReason": "Motivo de la impugnación (montaje faltante, importe erróneo…)",
  "ps.disputePlaceholder": "Ej.: el montaje del pedido OP-… del 12/09 no aparece en el extracto.",
  "ps.sendDispute": "Enviar impugnación",
  "ps.cancel": "Cancelar",
  "ps.stTitle": "Mis extractos mensuales",
  "ps.stIntro": "Cada extracto resume los montajes confirmados y realizados en su centro y el importe (IVA incl.) a facturarnos. Al terminar el mes, valídelo antes de emitir su factura, o impúgnelo si un montaje o importe es incorrecto.",
  "ps.trend": "{d} pt desde el {since}",
  "rel.excellent": "Excelente",
  "rel.good": "Bueno",
  "rel.average": "Medio",
  "rel.watch": "A vigilar",
  "rel.noData": "Datos insuficientes",
  "rel.tip": "Confirmación {c} % · Plazo de respuesta {d}/100 · Reasignaciones sufridas {r} ({rs}/100) · {n} pedido(s)",
  "rel.detail": "conf. {c} % · plazo {d} · reasig. {r}",
  "rel.weekTip": "Semana del {d}: {s}/100 ({l}, {n} pedido(s))",
  "nc.pushEnabledBg": "Notificaciones activadas (incluso con el sitio cerrado)",
  "nc.pushTest": "Enviarme una notificación de prueba",
  "nc.pushTestResult": "Notificación de prueba enviada a {sent} dispositivo(s) de {devices}.",
  "nc.pushTestNone": "Ningún dispositivo suscrito: active primero las notificaciones en este dispositivo.",
  "ps.pushIntro": "Reciba una alerta en este dispositivo, incluso con el espacio cerrado, en cuanto un cliente reserve, cambie o anule una franja de montaje, o se le reasigne un montaje.",
  "nc.ch.digest": "Resumen semanal",
  "nc.chDesc.digest": "Cada lunes por la mañana, un correo con sus notificaciones no leídas de la semana (desactivado por defecto).",
  "nc.digestOn": "Activado",
  "nc.digestOff": "Desactivado",
  "nc.pushTitle": "Notificaciones del navegador",
  "nc.pushDesc": "Reciba una alerta en su dispositivo en cuanto se confirme o cambie una cita de montaje o llegue una nueva notificación — incluso con el sitio cerrado (Web Push).",
  "nc.pushEnable": "Activar notificaciones del navegador",
  "nc.pushEnabled": "Notificaciones del navegador activadas",
  "nc.pushDisable": "Desactivar",
  "nc.pushDenied": "Bloqueadas por el navegador: permítalas en la configuración del sitio.",
  "nc.pushUnsupported": "Su navegador no admite notificaciones.",
  "track.title": "Seguimiento de la entrega",
  "track.created": "Pedido confirmado",
  "track.createdDesc": "Su pago ha sido validado, estamos preparando su pedido.",
  "track.processing": "En preparación",
  "track.processingDesc": "Sus piezas se están revisando y embalando en nuestro almacén.",
  "track.handed_over": "Paquete entregado al transportista",
  "track.shipped": "Enviado",
  "track.shippedDesc": "Su paquete está en camino.",
  "track.transit": "En tránsito",
  "track.delivered": "Entregado",
  "track.deliveredDesc": "Su paquete ha sido entregado. ¡Buen viaje!",
  "track.pending": "Pendiente",
  "track.eta": "Entrega estimada: {d}",
  "track.carrierLink": "Seguir en {carrier}",
  "track.noNumber": "Le comunicaremos el número de seguimiento en cuanto se envíe el pedido.",
  "track.help": "¿Una pregunta sobre su entrega? Todas las etapas se muestran aquí en tiempo real.",
  "track.lastUpdate": "Última actualización: {d}",
  "nc.ch.cart": "Recordatorio de cesta",
  "nc.chDesc.cart": "Un correo si deja artículos en su cesta durante 24 horas.",
  "nc.kind.delivery": "Entrega",
  "nc.ch.delivery": "Seguimiento de la entrega",
  "nc.chDesc.delivery": "Nueva etapa de entrega añadida a su pedido (preparación, tránsito, entrega).",
  "notif.k.delivery_step.title": "Nueva etapa de entrega — pedido {order}",
  "notif.k.delivery_step.body": "{step}{loc} Siga su paquete en tiempo real en Mis pedidos.",
  "notif.k.delivery_processing.title": "Su pedido {order} está en preparación",
  "notif.k.delivery_processing.body": "Sus piezas se están revisando y embalando en nuestro almacén. Siguiente paso: el envío.",
  "notif.k.delivery_shipped.title": "Su pedido {order} ha sido enviado",
  "notif.k.delivery_shipped.body": "Su paquete está en camino{loc}. Encontrará el número de seguimiento en Mis pedidos.",
  "notif.k.delivery_delivered.title": "Su pedido {order} ha sido entregado",
  "notif.k.delivery_delivered.body": "Su paquete ha llegado. ¡Buen viaje! No dude en valorar sus piezas.",
  "paylink.invalid": "Este enlace de pago no es válido.",
  "paylink.fillCard": "Complete todos los datos de la tarjeta.",
  "paylink.failed": "No se pudo realizar el pago.",
  "paylink.paid": "Este pedido ya está pagado. ¡Gracias!",
  "paylink.expired": "Este enlace de pago ha caducado. Contáctenos para recibir uno nuevo.",
  "paylink.revoked": "Este enlace ha sido sustituido por uno nuevo: consulte su último correo.",
  "paylink.cancelled": "Este pedido ha sido cancelado.",
  "paylink.successTitle": "Pago confirmado",
  "paylink.successBody": "¡Gracias! Su pedido {o} está confirmado y se preparará de inmediato. Le hemos enviado un correo de confirmación.",
  "paylink.orderFor": "Pedido preparado para {n}",
  "paylink.toPay": "A pagar",
  "paylink.cardTitle": "Pago seguro con tarjeta",
  "paylink.holder": "Nombre del titular",
  "paylink.payNow": "Pagar {a}",
  "paylink.secure": "Conexión cifrada · Sus datos bancarios nunca se almacenan.",
  "orders.awaitingPayment": "Pendiente de pago",
  "orders.payNow": "Pagar ahora",
  "checkout.sumupInfo": "Va a ser redirigido a la página de pago seguro de SumUp para introducir los datos de su tarjeta. Su pedido se confirmará en cuanto se acepte el pago.",
  "checkout.walletCoversAll": "Su crédito cubre la totalidad del pedido: no es necesario realizar ningún pago con tarjeta.",
  "checkout.redirecting": "Redirigiendo al pago seguro…",
  "checkout.errPayment": "El pedido está registrado, pero no se ha podido iniciar el pago. Vuelva a intentarlo o págue más tarde desde «Mis pedidos».",
  "checkout.retryPayment": "Reintentar el pago",
  "paylink.sumupInfo": "Va a ser redirigido a la página de pago seguro de SumUp (tarjeta bancaria, Apple Pay, Google Pay).",
  "payret.checking": "Verificando su pago…",
  "payret.checkingHint": "Gracias por esperar unos segundos; estamos confirmando el pago con SumUp.",
  "payret.paidTitle": "¡Pago confirmado!",
  "payret.paidBody": "Gracias por su pedido. Se le ha enviado un correo electrónico de confirmación y su pedido se preparará a partir de ahora.",
  "payret.failedTitle": "Pago no completado",
  "payret.failedBody": "El pago ha sido rechazado o cancelado. No se ha cobrado ningún importe. Sus artículos siguen reservados: puede intentarlo de nuevo.",
  "payret.pendingTitle": "Pago pendiente de confirmación",
  "payret.pendingBody": "Aún no hemos recibido la confirmación de SumUp. Si ha pagado correctamente, su pedido pasará automáticamente a «Pagado» en unos minutos.",
  "payret.retry": "Reintentar el pago",
  "payret.later": "Pagar más tarde",
  "payret.errorTitle": "Pedido no encontrado",
  "orders.refundCard": "Pedido reembolsado en su tarjeta bancaria ({a} €) — abono {n}.",
  "orders.refundCardPartial": "Reembolso parcial de {a} € efectuado en su tarjeta bancaria — abono {n}.",
  "orders.creditNotePdf": "Descargar el abono (PDF)",
  "product.viewSpecs": "Las características",
  "product.fitOk": "Compatible con su vehículo",
  "product.fitUniversal": "Producto universal: válido para todos los vehículos",
  "product.fitKo": "No es compatible con su vehículo",
  "product.fitSeeCompatible": "Ver las piezas compatibles",
  "product.fitChangeVehicle": "Cambiar de vehículo",
  "product.fitSelectHint": "Seleccione su vehículo para comprobar la compatibilidad",
  "product.fitSelectCta": "Seleccionar mi vehículo",
  "cmp.check": "Comparar",
  "cmp.checked": "En el comparador",
  "cmp.removed": "Retirado del comparador",
  "cmp.added": "Añadido al comparador ({n}/{max})",
  "cmp.maxReached": "Puede comparar {max} artículos como máximo",
  "cmp.sameSub": "Compare únicamente artículos de la misma subcategoría",
  "cmp.open": "Comparar",
  "cmp.barTitle": "Comparador",
  "cmp.barHint": "Marque de 2 a {max} artículos de la misma subcategoría",
  "cmp.barCompare": "Comparar ({n})",
  "cmp.barNeedTwo": "Añada al menos 2 artículos",
  "cmp.colHeader": "Característica",
  "cmp.specsTitle": "Características técnicas",
  "cmp.diffHint": "Las filas resaltadas indican diferencias entre los artículos.",
  "cmp.intro2": "{n}/{max} artículos · marque « Comparar » en las fichas de producto de una misma subcategoría.",
  "cmp.emptyHint2": "Explore el catálogo y marque « Comparar » en 2 a {max} artículos de una misma subcategoría.",
  "header.fastShipping": "Entrega rápida en 2-5 días",
  "product.deliverySubFast": "2 a 5 días laborables",
  "cart.fastShipping": "Entrega rápida en 2-5 días",
  "cart.freeShippingReached": "¡Envío gratis conseguido!",
  "header.deliveryCountry": "País de entrega",
  "header.freeFromShort": "gratis desde {n} €",
  "sess.title": "Dispositivos conectados",
  "sess.hint": "Sesiones actualmente conectadas a su cuenta. Desconecte un dispositivo que no reconozca o todos los demás a la vez.",
  "sess.logoutEverywhere": "Cerrar sesión en todas partes",
  "sess.logout": "Desconectar",
  "sess.thisDevice": "Este dispositivo",
  "sess.lastSeen": "Última actividad",
  "sess.remembered": "sesión recordada",
  "sess.revoked": "Dispositivo desconectado",
  "sess.revokedAll": "{n} dispositivo(s) desconectado(s)",
  "sess.confirmAll": "¿Desconectar todos los demás dispositivos? Seguirá conectado en este.",
  "sess.error": "Acción imposible, inténtelo de nuevo",
  "sess.empty": "Ninguna sesión activa",
  "cart.remove": "Eliminar",
  "cat.specs": "Características técnicas",
  "cat.specsHint": "Afine por dimensión, tipo o referencia técnica.",
  "cat.showMore": "Ver más ({n})",
  "cat.showLess": "Ver menos",
  "garage.savedToast": "Vehículo guardado en su garaje",
  "garage.restoredToast": "Su {v} se ha restaurado desde su cuenta",
  "garage.myVehicles": "Mis vehículos",
  "garage.manage": "Gestionar mi garaje",
  "cart.forVehicle": "Piezas para su vehículo",
  "equiv.search": "Filtrar…",
  "equiv.allBrands": "Todas las marcas ({n})",
  "equiv.brand": "Marca",
  "equiv.ref": "Referencia",
  "equiv.type": "Tipo",
  "equiv.oem": "OEM del fabricante",
  "equiv.alt": "Equivalencia",
  "equiv.unknownBrand": "—",
  "equiv.empty": "Ninguna referencia coincide con este filtro.",
  "equiv.seeAll": "Ver las {n} referencias ↓",
  "equiv.moreAlt": "+{n} equivalencias",
  "equiv.brandLink": "Ver todas las piezas que referencian {b}",
  "search.equivBrand": "Piezas que referencian {b}",
  "search.equivHint": "Piezas de la marca {b} y piezas de otros fabricantes que indican una referencia equivalente {b}.",
  "cart.fitOk": "Compatible con su {v}",
  "cart.fitNo": "No confirmado para su {v}",
  "cart.fitUniversal": "Pieza universal · todos los vehículos",
  "cart.fitCheck": "Ver la ficha",
  "cart.fitWarn": { one: "{n} artículo no está confirmado para su {v}: compruebe su compatibilidad antes de pedirlo.", other: "{n} artículos no están confirmados para su {v}: compruebe su compatibilidad antes de pedirlos." },
  "alt.compatible": "Alternativa compatible con su {v} de {brand}",
  "alt.samePrice": "mismo precio",
  "alt.morePerUnit": "+{d} € / unidad",
  "cart.garageSwitch": "Cambiar de vehículo (mi garaje)",
  "cart.garagePick": "Elegir un vehículo de mi garaje…",
  "cart.garageHint": "La compatibilidad de los artículos se vuelve a comprobar al instante.",
  "notify.button": "Avisarme cuando vuelva a estar en stock",
  "notify.title": "Alerta de reposición",
  "notify.text": "Deje su correo: le escribiremos en cuanto esta pieza vuelva a estar disponible (una sola vez, sin compromiso).",
  "notify.emailPh": "su@email.es",
  "notify.submit": "Avisarme",
  "notify.done": "¡Anotado! Recibirá un correo en cuanto vuelva a estar en stock.",
  "notify.already": "Ya está inscrito para esta pieza.",
  "notify.subscribed": "Alerta activada: le avisaremos por correo",
  "notify.cancel": "Cancelar la alerta",
  "notify.error": "No se pudo registrar su solicitud. Compruebe la dirección de correo.",
  "notify.priceButton": "Avisarme si baja el precio",
  "notify.priceTitle": "Alerta de bajada de precio",
  "notify.priceText": "Deje su correo: le escribiremos en cuanto baje el precio de esta pieza (una sola vez, sin compromiso).",
  "notify.priceDone": "¡Anotado! Recibirá un correo si baja el precio.",
  "notify.priceAlready": "Ya sigue el precio de esta pieza.",
  "notify.priceSubscribed": "Alerta de precio activada: le avisaremos por correo",
  "acc.referral": "Apadrinamiento",
  "share.rewardHint": "−{p} % de regalo si un amigo hace su 1.er pedido con su enlace.",
  "share.rewardMore": "Mis recompensas",
  "share.rewardGuest": "Inicie sesión: −{p} % de regalo si un amigo pide con su enlace.",
  "share.rewardLogin": "Iniciar sesión",
  "share.refTitle": "Comparta y gane −{p} %",
  "share.refHow": "Cada vez que un amigo realiza su primer pedido tras abrir un enlace que usted compartió (página, producto, comparativa, guía), recibe por e-mail un código personal de −{p} % válido {d} días. Los botones de compartir del sitio añaden su código automáticamente.",
  "share.refDisabled": "El programa está suspendido temporalmente.",
  "share.refWhatsapp": "Aquí pido mis piezas de coche, echa un vistazo:",
  "share.refTip": "Consejo: comparta directamente una ficha de producto o su selección de vehículo — el enlace ya contiene su código.",
  "share.refTotal": "Recompensas ganadas",
  "share.refActive": "Códigos por usar",
  "share.refRewards": "Mis códigos",
  "share.refEmpty": "Ninguna recompensa todavía: ¡comparta sus piezas favoritas con sus allegados!",
  "share.refStatus_active": "Por usar",
  "share.refStatus_used": "Usado",
  "share.refStatus_expired": "Caducado",
  "share.refFriend": "Amigo {f} · {d}",
  "share.refUntil": "hasta el {d}",
  "share.tier_none": "Sin rango todavía",
  "share.tier_bronze": "Padrino Bronce",
  "share.tier_silver": "Padrino Plata",
  "share.tier_gold": "Padrino Oro",
  "share.badgeFriends": "{n} amigo(s) convertido(s)",
  "share.badgeNext": "{n} amigo(s) más para ser {tier}",
  "share.badgeMax": "Rango máximo alcanzado — ¡gracias!",
  "share.badgeLevels": "Bronce desde 1 amigo · Plata desde 3 · Oro desde 10",
  "acc.alerts": "Mis alertas",
  "alerts.intro": "Sus alertas «Avisarme»: reposición y bajada de precio. Cada alerta le envía un solo correo y luego desaparece de esta lista.",
  "alerts.active": { one: "{n} alerta activa", other: "{n} alertas activas" },
  "alerts.empty": "Ninguna alerta activa. En una ficha de producto, pulse «Avisarme» para saber cuándo vuelve el stock o baja el precio.",
  "alerts.kindStock": "Reposición",
  "alerts.kindPrice": "Bajada de precio",
  "alerts.remove": "Eliminar",
  "alerts.removeAll": "Eliminar todas",
  "alerts.removed": "Alerta eliminada",
  "alerts.removedAll": "Todas las alertas eliminadas",
  "alerts.error": "Acción imposible, inténtelo de nuevo",
  "alerts.since": "desde el {d}",
  "alerts.priceWatch": "Precio seguido: {p} €",
  "alerts.now": "hoy",
  "alerts.backSoon": "De nuevo en stock — correo en camino",
  "alerts.history": "Alertas enviadas (últimos 90 días)",
  "alerts.sentOn": "enviada el {d}",
  "wl.priceAlerts": "Alerta de precio en toda la lista",
  "wl.priceAlertsHint": "Reciba un correo en cuanto baje el precio de una pieza de su lista",
  "wl.priceAlertsDone": "Alerta de precio activada en {n} pieza(s) ({a} ya seguida(s)). Las encontrará en Mis alertas.",
  "equiv.showMore": "Ver más ({n} referencias más)",
  "equiv.showLess": "Ver menos",
  "spec.equivalences": "Referencias equivalentes",
  "header.matchesEan": "Coincide con el código EAN ",
  "product.compatVerified": { one: "Compatibilidades verificadas mediante {n} pieza equivalente", other: "Compatibilidades verificadas mediante {n} piezas equivalentes" },
  "equiv.compareTitle": "Comparar las equivalencias lado a lado",
  "equiv.compareSub": "{n} piezas equivalentes · la columna resaltada es la pieza consultada",
  "equiv.openComparator": "Abrir en el comparador",
  "equiv.current": "Pieza consultada",
  "equiv.colBrand": "Marca",
  "equiv.colRef": "Referencia",
  "equiv.colPrice": "Precio con IVA",
  "equiv.colRating": "Opiniones de clientes",
  "equiv.colDelivery": "Entrega",
  "equiv.colStock": "Stock",
  "equiv.colType": "Tipo",
  "equiv.cheapest": "El más barato",
  "equiv.bestRated": "Mejor valorado",
  "equiv.fastest": "el más rápido",
  "equiv.bestMarket": "Mejor precio del mercado",
  "equiv.stockLine": "{w} almacén",
  "equiv.stockSupplier": " · +{s} proveedor",
  "equiv.outOfStock": "Sin stock",
  "equiv.supplierDelay": "En {n} d (proveedor)",
  "equiv.ship24": "Enviado en 24 h",
  "equiv.unavailable": "No disponible",
  "equiv.viewProduct": "Ver la ficha",
  "equiv.hideCompare": "Ocultar la comparativa",
  "equiv.showCompare": "Mostrar la comparación",
  "common.close": "Cerrar",
  "scan.title": "Escanear el código de barras EAN",
  "scan.hint": "Coloque el código de barras de la pieza o de su embalaje en el marco: la ficha se abre automáticamente.",
  "scan.denied": "Acceso a la cámara denegado. Autorice la cámara en su navegador y vuelva a intentarlo.",
  "scan.unavailable": "Cámara no disponible en este dispositivo. Introduzca el código EAN en la barra de búsqueda.",
  "scan.found": "Pieza encontrada: {name}",
  "equiv.share": "Compartir la comparativa",
  "equiv.shareWhatsapp": "Enviar por WhatsApp",
  "equiv.shareCopy": "Copiar el enlace",
  "equiv.shareCopied": "Enlace de la comparativa copiado",
  "equiv.shareText": "¿Puede decirme qué pieza elegir? Comparativa OTOPIECES : {names}",
  'cmp.shared': { one: 'Comparativa compartida — {n} pieza', other: 'Comparativa compartida — {n} piezas' },
  "cmp.shareTitle": "Compartir esta comparativa",
  "fb.title": "Nuestras grandes marcas",
  "fb.all": "Todas las marcas",
  "fb.nav": "Marcas de piezas",
  "fb.parts": "Piezas {b}",
  "fb.logo": "Logo {b}",
  "seo.defaultTitle": "Recambios de coche baratos online — Piezas para todas las marcas",
  "seo.defaultDesc": "Recambios de automóvil al mejor precio en OTOPIECES.COM: frenos, filtros, motor, neumáticos… Búsqueda por vehículo o matrícula, entrega en 2-5 días, devolución 14 días.",
  "vb.title": "Recambios por marca de vehículo",
  "vb.meta": "Elija la marca de su vehículo (Renault, Peugeot, Volkswagen, BMW, Citroën…) para encontrar todos los modelos y las piezas compatibles.",
  "vb.crumb": "Marcas de vehículos",
  "vb.intro": "Seleccione la marca de su coche para descubrir todos sus modelos y las piezas compatibles: frenos, filtración, motor, neumáticos…",
  "vb.searchPh": "Buscar una marca…",
  "vb.popular": "Marcas más vendidas",
  "vb.all": "Todas las marcas ({n})",
  "vb.models": { "one": "{n} modelo", "other": "{n} modelos" },
  "vb.brandTitle": "Recambios {b} baratos — todos los modelos",
  "vb.brandFallback": "Marca de vehículo",
  "vb.brandH1": "Recambios {b}",
  "vb.brandStats": "{m} modelo(s) · {p} pieza(s) compatible(s)",
  "vb.brandExcerpt": "Elija su modelo {b} abajo, luego el año y la motorización para mostrar solo las piezas que encajan exactamente con su vehículo.",
  "vb.brandEmpty": "Los modelos {b} llegarán pronto.",
  "vb.selectVehicle": "Seleccionar un vehículo",
  "vb.topParts": "Piezas compatibles {b} más solicitadas",
  "vb.faqTitle": "Preguntas frecuentes sobre {k}",
  "vb.faqParts": "las piezas {b}",
  "vb.notFound": "Marca no encontrada.",
  "vb.seeAll": "Ver todas las marcas",
  "vm.notFound": "Modelo no encontrado.",
  "vm.seeBrandModels": "Ver los modelos de la marca",
  "vm.useVehicle": "Usar este vehículo para todo el catálogo",
  "vm.shareParts": "Compartir las piezas compatibles",
  "vm.share": "Compartir…",
  "vm.empty": "Aún no hay piezas referenciadas para este modelo.",
  "vm.otherModels": "Ver los otros modelos {b}",
  "vm.engineEmpty": "No hay piezas referenciadas para la motorización «{e}».",
  "vm.allEngines": "Ver todas las motorizaciones",
  "vm.frequent": "Búsquedas frecuentes",
  "vm.wholeCategory": "Toda la categoría",
  "vm.faqTitle": "Preguntas frecuentes — piezas {car}",
  "vm.faqFitQ": "¿Cómo estar seguro de que una pieza encaja en mi {car}?",
  "vm.faqFitA": "Cada pieza de esta página está referenciada para el {model}. Haga clic en su motorización arriba (o introduzca su matrícula en la página de inicio): solo se muestran las referencias compatibles con su versión.",
  "vm.faqPartsQ": "¿Qué piezas hay para el {car}?",
  "vm.faqPartsA": "El catálogo {model} cubre actualmente: {cats}. Se amplía regularmente con nuevas referencias.",
  "vm.faqPartsEmpty": "El catálogo {model} está en construcción.",
  "vm.faqDeliveryQ": "¿Cuáles son los plazos de entrega?",
  "vm.faqDeliveryA": "Las piezas en stock se envían en 24 h y se entregan en 2 a 5 días laborables. También puede reservar el montaje en un centro asociado al realizar el pedido.",
  "vm.h1": "Recambios {car}",
  "vm.intro": "Encuentre abajo todas las piezas verificadas para el {car}. Seleccione su motorización para mostrar solo las referencias que le corresponden exactamente.",
  "vm.stats": "{e} motorización(es) · {p} pieza(s) compatible(s)",
  "vm.filtered": "{n} pieza(s){e}",
  "vm.forEngine": " para {e}",
  "vm.added": "Añadido al carrito",
  "vm.addError": "No se pudo añadir al carrito",
  "pp.noVehicleTitle": "Ningún vehículo seleccionado",
  "pp.noVehicleText": "Seleccione su vehículo para mostrar solo las piezas compatibles.",
  "pp.selectVehicle": "Seleccionar mi vehículo",
  "pp.backHome": "Volver al inicio",
  "pp.title": "Piezas compatibles con su vehículo",
  "pp.metaTitle": "Recambios compatibles con su vehículo",
  "pp.metaDesc": "Seleccione su vehículo (marca, modelo, motorización o matrícula) y descubra las piezas 100 % compatibles en OTOPIECES.COM.",
  "pp.metaTitleVehicle": "Recambios {v}",
  "pp.metaDescVehicle": "Todas las piezas compatibles con su {v}: frenos, filtración, motor, embrague… al mejor precio en OTOPIECES.COM.",
  "pp.categories": "Categorías",
  "br.title": "Los modelos más baratos de mantener: ranking del presupuesto anual en piezas",
  "br.h1": "Los modelos más baratos de mantener",
  "br.crumb": "Presupuesto de mantenimiento",
  "br.metaDefault": "Ranking de modelos de vehículos por presupuesto anual de mantenimiento estimado a partir de las piezas compatibles.",
  "br.meta": "Ranking de {n} modelos por presupuesto anual de mantenimiento estimado (piezas de desgaste compatibles × frecuencia habitual). Del más económico ({min}/año) al más caro ({max}/año), sin mano de obra.",
  "br.intro": "Para cada modelo estimamos el presupuesto anual en piezas de mantenimiento a partir de las piezas compatibles referenciadas en OTOPIECES.COM: filtros, frenos, bujías, correas, amortiguadores… multiplicadas por su frecuencia habitual de sustitución. Precio mediano de las piezas compatibles, o presupuesto «eco» con la pieza más barata. Sin mano de obra, todas las motorizaciones juntas.",
  "br.error": "Ranking no disponible por el momento.",
  "br.allBrands": "Todas las marcas ({n})",
  "br.itemStats": "{p} de {pt} conceptos estimados · {n} piezas compatibles · {e} motorizaciones",
  "br.perYear": "/ año",
  "br.eco": "eco {v} / año",
  "br.footnote": "Ranking recalculado cada noche{d}. Estimaciones indicativas, sin mano de obra.",
  "br.lastUpdate": " · última actualización {d}",
  "br.ctaQ": "¿Tiene uno de estos modelos?",
  "br.ctaLink": "Añádalo a su garaje",
  "br.ctaRest": " para un presupuesto de su motorización exacta, un libro de mantenimiento y recordatorios por e-mail.",
  "br.faqTitle": "Preguntas frecuentes",
  "br.faq1q": "¿Cómo se calcula el presupuesto de mantenimiento?",
  "br.faq1a": "Consideramos 22 conceptos de desgaste (cambio de aceite, filtros, pastillas, discos, bujías, correas, distribución, amortiguadores…). Para cada concepto, el precio mediano de las piezas compatibles referenciadas se divide por la frecuencia habitual de sustitución (p. ej. pastillas cada 2 años). La suma da el presupuesto anual suavizado. Un modelo solo entra en el ranking con al menos 3 conceptos estimados.",
  "br.faq2q": "¿Cuál es el modelo más barato de mantener?",
  "br.faq2a": "Según nuestras estimaciones, {car} encabeza la lista con unos {m} en piezas de mantenimiento al año a precio mediano ({e} en eco). La mediana de los {n} modelos clasificados es de {med}/año.",
  "br.faq3q": "¿El presupuesto incluye la mano de obra?",
  "br.faq3a": "No: se trata únicamente del presupuesto en piezas, todas las motorizaciones juntas. Añada su vehículo a su garaje para obtener un presupuesto de su motorización exacta, un libro de mantenimiento con vencimientos en meses y kilómetros, y recordatorios por e-mail.",
  "cm.pickError": "Elija dos o tres vehículos de su garaje para comparar.",
  "cm.failed": "Comparación imposible",
  "cm.title": "Comparativa de piezas: {v}",
  "cm.meta": "Piezas compatibles comunes y específicas entre {v}.",
  "cm.crumbGarage": "Mi garaje",
  "cm.crumb": "Comparativa de modelos",
  "cm.parts": "{n} pieza(s)",
  "cm.forThisEngine": " para esta motorización",
  "cm.engines": " · {n} motorización(es)",
  "cm.budget": "Presupuesto de mantenimiento ~{m} €/año",
  "cm.budgetEco": "(eco {e} €)",
  "cm.cheapest": "el más barato de mantener",
  "cm.budgetNone": "Presupuesto de mantenimiento no estimado",
  "cm.part": "Pieza",
  "cm.price": "Precio",
  "cm.exactEngine": "Mi motorización exacta",
  "cm.allEngines": "Todas las motorizaciones del modelo",
  "cm.exactHint": "Solo se comparan las piezas previstas para la motorización de cada vehículo (o sin restricción de motor).",
  "cm.allHint": "Se comparan todas las piezas del modelo, sea cual sea la motorización.",
  "cm.all": "Todo ({n})",
  "cm.common2": "Comunes a los dos ({n})",
  "cm.common3": "Comunes a los tres ({n})",
  "cm.partial": "Comunes a dos de tres ({n})",
  "cm.only": "Solo {m} ({n})",
  "cm.onlyCol": "Solo {m}",
  "cm.common2Col": "Comunes a los dos",
  "cm.empty": "Ninguna pieza en esta selección.",
  "wl.title": "Mi lista de deseos",
  "wl.empty": "Ninguna pieza guardada. Haga clic en el corazón de un producto para encontrarlo aquí.",
  "acc.addressIntro": "Sus direcciones se proponen al realizar el pedido. La dirección de entrega predeterminada se rellena automáticamente.",
  "acc.walletIntro": "Su cuenta de depósito la alimenta nuestro servicio de atención al cliente (reembolso en saldo, gesto comercial, vale).",
  "acc.prefsNote": "La tienda está disponible en 5 idiomas y en euros; sus preferencias quedan guardadas.",
  "acc.proHt": "Precios sin IVA",
  "acc.proInvoices": "Facturas a nombre de su empresa",
  "acc.proBadge": "Distintivo Pro en su cuenta",
  "va.title": "Alertas de vehículo",
  "va.intro": "Reciba un e-mail cuando se añadan nuevas piezas compatibles con sus modelos — en resumen semanal (lunes) o en cada incorporación.",
  "va.empty": "Ninguna alerta de vehículo. Active una desde la página de un modelo.",
  "va.browse": "Explorar los vehículos",
  "auth.showPassword": "Mostrar la contraseña",
  "brands.kicker": "Nuestros fabricantes",
  "brand.empty": "Ningún producto {b}{cat}{veh}.",
  "brand.emptyCat": " en esta categoría",
  "brand.emptyVeh": " compatible con su vehículo",
  "brand.seeUnfiltered": "Ver los {n} productos sin filtrar por vehículo",
  "brand.relatedSearches": "Búsquedas relacionadas",
  "cmp.pageTitle": "Comparación de productos",
  "common.new": "Nuevo",
  "vm.metaDesc": "Todas las piezas compatibles con el {car}: {cats}. {e} motorización(es) ({engines}…). Compatibilidad verificada, entrega en 2-5 días.",
  "ship.title": "Envío y seguimiento",
  "ship.metaDesc": "Plazos, gastos de envío y transportistas de OTOPIECES.COM.",
  "ship.metaFree": "Envío gratuito a partir de {free}.",
  "ship.eyebrow": "Envío",
  "ship.heading": "Envío rápido y con seguimiento",
  "ship.headingFree": "Envío rápido, con seguimiento, gratuito a partir de {free}",
  "ship.intro": "Expedición en 24 h laborables desde nuestro almacén en Francia. Elija el transportista que más le convenga.",
  "ship.fees": "Gastos de envío",
  "ship.feesFree": "{fee} · gratis a partir de {free}",
  "ship.avgDelay": "Plazo medio",
  "ship.avgDelayValue": "2 a 5 días laborables",
  "ship.insured": "Paquete asegurado",
  "ship.insuredValue": "Rotura o pérdida reembolsada",
  "ship.how": "¿Cómo funciona?",
  "ship.s1": "Pedido validado",
  "ship.s1Text": "Confirmación inmediata por e-mail con su número de pedido.",
  "ship.s2": "Preparación",
  "ship.s2Text": "Piezas verificadas y embaladas en 24 h laborables en nuestro almacén.",
  "ship.s3": "Expedición",
  "ship.s3Text": "E-mail con el número de seguimiento y el enlace del transportista.",
  "ship.s4": "Entrega",
  "ship.s4Text": "A domicilio, en el taller o en un punto de recogida, según su elección.",
  "ship.carriers": "Nuestros transportistas",
  "ship.c1Delay": "2–4 días laborables",
  "ship.c1Note": "Entrega a domicilio o en oficina de correos",
  "ship.c2Delay": "24–48 h",
  "ship.c2Note": "Exprés, ideal para urgencias de taller",
  "ship.c3Delay": "2–3 días laborables",
  "ship.c3Note": "Paquetes voluminosos (parachoques, capós…)",
  "ship.c4Delay": "3–5 días laborables",
  "ship.c4Note": "Recogida en punto de entrega, económico",
  "ship.trackingKicker": "Seguimiento del paquete",
  "ship.trackingTitle": "¿Dónde está mi pedido?",
  "ship.trackingText": "Consulte el estado, el transportista y el número de seguimiento en su espacio de cliente.",
  "ship.trackCta": "Seguir mi pedido",
  "cat.metaSubFallback": "{sub} ({cat}) al mejor precio en OTOPIECES.COM: {brands}, compatibilidad garantizada con su vehículo, entrega en 2-5 días, devolución 14 días.",
  "cat.metaFallback": "Compre sus piezas de {cat} al mejor precio en OTOPIECES.COM: grandes marcas ({brands}), compatibilidad garantizada con su vehículo, entrega en 2-5 días.",
  "vg.today": "hoy",
  "vg.budgetInline": "presupuesto de mantenimiento ~{m} €/año",
  "vg.engines": "Motorizaciones {m}",
  "vg.allN": "Todas ({n})",
  "vg.popular": "Popular",
  "vg.engAbbr": "{n} mot.",
  "vg.choose": "Elegir",
  "vg.parts": "Piezas",
  "vg.seeParts": "Ver todas las piezas compatibles {m}",
  "vg.allModels": "Todos los modelos {b}",
  "vg.searchModel": "Buscar un modelo…",
  "vg.gallery": "Galería",
  "vg.list": "Lista",
  "vg.noMatch": "Ningún modelo coincide con «{q}».",
  "vg.popularTitle": "Modelos {b} más buscados",
  "vg.popularByUsage": "Según las selecciones y los garajes de nuestros clientes.",
  "vg.popularByParts": "Los modelos con más piezas disponibles.",
  "vg.generations": { "one": "{n} generación", "other": "{n} generaciones" },
  "vg.yearsEstimated": "* años orientativos",
  "mb.title": "Presupuesto anual de mantenimiento estimado — {car}",
  "mb.intro": "Estimación a partir de las {n} piezas de desgaste compatibles referenciadas ({p} conceptos de {pt}), todas las motorizaciones juntas: precio mediano, o «eco» con la pieza más barata, dividido por la frecuencia habitual de sustitución.",
  "mb.eco": "Eco: {v} / año",
  "mb.hideDetail": "Ocultar el detalle",
  "mb.showDetail": "Ver el detalle por concepto",
  "mb.rankingLink": "Ver el ranking de los modelos más baratos de mantener",
  "mb.garageLink": "Añada este vehículo a su garaje para un presupuesto de su motorización exacta y un libro de mantenimiento",
  "mb.colItem": "Concepto",
  "mb.colFreq": "Frecuencia",
  "mb.colEco": "Eco",
  "mb.colMedian": "Precio mediano",
  "mb.colYear": "Al año",
  "mb.every": { "one": "cada año", "other": "cada {n} años" },
  "mb.missing": "No estimados (aún sin pieza compatible): {list}",
  "val.cta": "Avisarme de las nuevas piezas",
  "val.activated": "¡Alerta activada ({f}{e})!",
  "val.weeklyShort": "resumen semanal",
  "val.instantShort": "en cada incorporación",
  "val.already": "Alerta ya activa",
  "val.active": "Alerta de nuevas piezas activa",
  "val.disable": "Desactivar",
  "val.formTitle": "Recibir un e-mail cuando se añadan nuevas piezas compatibles",
  "val.emailPh": "su@email.es",
  "val.enable": "Activar",
  "val.onlyEngine": "Solo mi motorización",
  "val.weekly": "Resumen semanal (lunes)",
  "val.instant": "En cada incorporación",
  "val.error": "No se pudo activar la alerta, compruebe la dirección de e-mail.",
  "val.notifyWhenAdded": "Avisarme en cuanto se añada una pieza",
  "gar.alertEnabledNote": "Alerta «nuevas piezas» activada (resumen semanal).",
  "gar.alertOptIn": "Avisarme por e-mail de las nuevas piezas compatibles con este vehículo",
  "gar.alertOptInHint": "(resumen semanal, modificable en Mis alertas)",
  "vb.brandMeta": "Recambios {b}: {m} modelos ({fams}…) y {p} piezas compatibles al mejor precio. Frenos, filtración, motor, neumáticos.",
  "vb.partsInCat": "Piezas {c} {b} ({n})",
  "vb.allParts": "Todas las piezas",
  "vb.noPartsInCat": "Aún no hay piezas de esta categoría para esta marca.",
  "vb.modelFilter": "Filtrar por modelo",
  "vb.allModelsOpt": "Todos los modelos",
  "vb.partsForModel": "Piezas compatibles con {b} ({n})",
  "vb.modelPage": "Ficha del modelo",
  "vb.noPartsForModel": "Aún no hay piezas de esta categoría compatibles con este modelo.",
  "vb.modelsWithParts": "Modelos con piezas referenciadas",
  "vb.modelsOther": "Otros modelos",
  "vb.engineFilter": "Filtrar por motorización",
  "vb.allEnginesOpt": "Todas las motorizaciones",
  "fuel.essence": "Gasolina", "fuel.diesel": "Diésel", "fuel.hybride": "Híbrido", "fuel.essence/électrique": "Híbrido gasolina", "fuel.diesel/électrique": "Híbrido diésel", "fuel.électrique": "Eléctrico", "fuel.gpl": "GLP",
  "fuel.essence/gpl": "Gasolina / GLP", "fuel.essence/éthanol": "Gasolina / etanol",
  "vb.garageAdd": "Añadir a mi garaje",
  "vb.garageSee": "En mi garaje — ver",
  "vb.garageAdded": "{car} añadido a su garaje.",
  "vb.garageAlready": "Este vehículo ya está en su garaje.",
  "vb.garageError": "No se pudo añadir este vehículo.",
  "vb.garageLoginHint": "Inicie sesión para guardar este vehículo en su garaje",
  "vb.alertCta": "Avisarme de las nuevas piezas {m}",
  "vb.share": "Compartir esta selección",
  "vb.shareText": "Piezas compatibles {sel} en OTOPIECES.COM",
  "vb.shareCopied": "Enlace de la selección copiado al portapapeles.",
  "vb.shareCopiedShort": "Enlace copiado",
  "vb.shareCopyManual": "Copie este enlace:",
  "vb.shareCheapest": "Las 3 piezas más baratas:",
  "vb.shareWhatsappHint": "Enviar la selección y las 3 piezas más baratas por WhatsApp",
  "fuelR.title": "Energía",
  "fuelR.all": "Todas las motorizaciones",
  "fuelR.essence": "Gasolina",
  "fuelR.diesel": "Diésel",
  "fuelR.electrique": "100 % eléctrico",
  "fuelR.reserved": "Solo para motores:",
  "fuelR.vehicleHint": "Orden por relevancia: primero las piezas {e} de su vehículo",
  "product.fitFuelKo": "Solo para motores {e} — su vehículo es {ve}",
  "cart.fitFuel": "Solo {e} · su {v} es {ve}",
  "garage.additivesTitle": "Aditivos recomendados",
  "garage.additivesHint": "Aditivos y limpiadores adaptados a la energía de cada uno de sus vehículos.",
  "garage.additivesEmpty": "Ningún aditivo compatible por ahora.",
  "garage.additiveHint": "No olvide el aditivo:",
  "packEss.title": "Pack mantenimiento gasolina",
  "packEss.onAdditive": "en el aditivo",
  "packEss.desc": "Este aceite + un aditivo de combustible gasolina: -{p} % en el aditivo, descuento aplicado automáticamente al pagar.",
  "packEss.total": "El lote:",
  "packEss.add": "Añadir el lote al carrito",
  "packEss.done": "Lote añadido",
  "packEss.added": "Lote añadido al carrito — código {c} aplicado",
  "packEss.addedLogin": "Lote añadido — el descuento {c} se aplicará al pagar tras iniciar sesión",
  "packEss.code": "Descuento con el código {c}, válido con un aceite de motor en el carrito.",
  "packEss.titleDiesel": "Pack mantenimiento diésel",
  "packEss.descDiesel": "Este aceite + un aditivo diésel o limpiador FAP: -{p} % en el aditivo, descuento aplicado automáticamente al pagar.",
  "packEss.cartDesc": "Su aceite de motor está solo en el carrito: complete el lote con el aditivo adecuado, -{p} % en él.",
  "packEss.cartAdd": "Añadir el aditivo al lote (-{p} %)",
};

export default es;
